{
  "simplified": {
    "common": [
      "⺁",
      "⺆",
      "⺈",
      "⺌",
      "⺕",
      "⺳",
      "⺽",
      "㇇",
      "㇏",
      "㐄",
      "㐆",
      "㐌",
      "㐫",
      "㐬",
      "㐭",
      "㐱",
      "㒸",
      "㓞",
      "㔾",
      "㕣",
      "㗊",
      "㝉",
      "㝴",
      "㝵",
      "㠯",
      "㡀",
      "㢆",
      "㣎",
      "㣺",
      "㫃",
      "㫗",
      "㳟",
      "㸒",
      "㸚",
      "䍃",
      "䏍",
      "䏎",
      "䒑",
      "䖝",
      "䖵",
      "䚯",
      "䧹",
      "䩗",
      "一",
      "丁",
      "丂",
      "七",
      "丄",
      "丆",
      "万",
      "丈",
      "三",
      "上",
      "下",
      "丌",
      "不",
      "与",
      "丐",
      "丑",
      "专",
      "且",
      "丕",
      "世",
      "丘",
      "丙",
      "业",
      "东",
      "丞",
      "两",
      "並",
      "丨",
      "丩",
      "丬",
      "中",
      "丯",
      "丰",
      "串",
      "丵",
      "丶",
      "丷",
      "丸",
      "丹",
      "为",
      "主",
      "丿",
      "乁",
      "乂",
      "乃",
      "乄",
      "久",
      "乇",
      "义",
      "之",
      "乌",
      "乍",
      "乎",
      "乏",
      "乐",
      "乑",
      "乔",
      "乘",
      "乙",
      "乚",
      "乛",
      "乜",
      "九",
      "乞",
      "也",
      "习",
      "买",
      "亅",
      "了",
      "亇",
      "予",
      "争",
      "二",
      "于",
      "亏",
      "云",
      "五",
      "井",
      "亘",
      "亚",
      "亠",
      "亡",
      "亢",
      "交",
      "亥",
      "亦",
      "产",
      "亨",
      "享",
      "京",
      "亭",
      "亲",
      "亶",
      "人",
      "亻",
      "亼",
      "亾",
      "今",
      "介",
      "仌",
      "从",
      "仑",
      "仒",
      "仓",
      "付",
      "代",
      "令",
      "以",
      "任",
      "伏",
      "伐",
      "会",
      "何",
      "余",
      "你",
      "佥",
      "佰",
      "侯",
      "便",
      "保",
      "俞",
      "倝",
      "倠",
      "儿",
      "兀",
      "允",
      "元",
      "兄",
      "充",
      "兆",
      "先",
      "光",
      "克",
      "兌",
      "免",
      "兒",
      "兔",
      "入",
      "全",
      "兪",
      "八",
      "公",
      "六",
      "兰",
      "共",
      "关",
      "兴",
      "兵",
      "其",
      "具",
      "典",
      "兹",
      "兼",
      "冂",
      "冃",
      "冄",
      "内",
      "円",
      "冈",
      "冉",
      "冊",
      "冋",
      "册",
      "冎",
      "冏",
      "冒",
      "冖",
      "冗",
      "冘",
      "写",
      "军",
      "农",
      "冡",
      "冫",
      "冬",
      "几",
      "凡",
      "凧",
      "凵",
      "凶",
      "出",
      "击",
      "函",
      "刀",
      "刁",
      "刂",
      "刃",
      "刅",
      "分",
      "切",
      "刍",
      "刑",
      "刖",
      "列",
      "刘",
      "则",
      "利",
      "别",
      "到",
      "刷",
      "剌",
      "前",
      "力",
      "办",
      "加",
      "务",
      "劦",
      "助",
      "劳",
      "勃",
      "勹",
      "勺",
      "勾",
      "勿",
      "匀",
      "匃",
      "包",
      "匆",
      "匈",
      "匊",
      "匋",
      "匍",
      "匕",
      "化",
      "北",
      "匚",
      "匝",
      "匡",
      "匹",
      "区",
      "匽",
      "十",
      "卂",
      "千",
      "卅",
      "午",
      "卉",
      "半",
      "华",
      "卑",
      "卒",
      "卓",
      "单",
      "卖",
      "南",
      "単",
      "卜",
      "占",
      "卢",
      "卦",
      "卩",
      "卪",
      "卬",
      "卯",
      "危",
      "即",
      "却",
      "卵",
      "卷",
      "卸",
      "厂",
      "厃",
      "厄",
      "历",
      "厈",
      "厉",
      "厓",
      "原",
      "厨",
      "厶",
      "厷",
      "去",
      "厽",
      "县",
      "叀",
      "参",
      "又",
      "叉",
      "及",
      "友",
      "双",
      "反",
      "収",
      "叐",
      "发",
      "叒",
      "叔",
      "叕",
      "取",
      "受",
      "叚",
      "叟",
      "口",
      "古",
      "句",
      "另",
      "叩",
      "只",
      "召",
      "可",
      "台",
      "史",
      "右",
      "司",
      "吂",
      "各",
      "合",
      "吉",
      "吊",
      "同",
      "名",
      "后",
      "吏",
      "向",
      "吕",
      "君",
      "吴",
      "吾",
      "呆",
      "呈",
      "告",
      "员",
      "呙",
      "周",
      "咅",
      "咠",
      "咢",
      "咸",
      "品",
      "哥",
      "唐",
      "啇",
      "啚",
      "啬",
      "喜",
      "喿",
      "囗",
      "囚",
      "回",
      "囟",
      "因",
      "困",
      "囱",
      "囷",
      "土",
      "圡",
      "圣",
      "圤",
      "圥",
      "在",
      "圭",
      "圼",
      "坐",
      "坴",
      "垂",
      "基",
      "堂",
      "堇",
      "士",
      "壬",
      "壮",
      "声",
      "壴",
      "夂",
      "夃",
      "夅",
      "夆",
      "备",
      "夋",
      "夌",
      "复",
      "夏",
      "夓",
      "夕",
      "夗",
      "多",
      "夜",
      "大",
      "天",
      "太",
      "夫",
      "夬",
      "夭",
      "央",
      "夰",
      "失",
      "头",
      "夷",
      "夸",
      "夹",
      "奂",
      "奄",
      "奇",
      "奈",
      "奉",
      "奏",
      "奚",
      "奧",
      "女",
      "奴",
      "如",
      "妟",
      "妥",
      "妻",
      "妾",
      "姑",
      "委",
      "娄",
      "婴",
      "子",
      "孔",
      "存",
      "孙",
      "孚",
      "孛",
      "孝",
      "孟",
      "孰",
      "宀",
      "宁",
      "它",
      "安",
      "完",
      "宓",
      "宗",
      "官",
      "定",
      "宛",
      "宜",
      "审",
      "客",
      "宣",
      "宩",
      "害",
      "家",
      "宷",
      "容",
      "宾",
      "宿",
      "寅",
      "察",
      "寸",
      "对",
      "寺",
      "寿",
      "尃",
      "射",
      "将",
      "尉",
      "尊",
      "小",
      "少",
      "尔",
      "尗",
      "尚",
      "尝",
      "尞",
      "尢",
      "尤",
      "尧",
      "尸",
      "尹",
      "尺",
      "尼",
      "尿",
      "居",
      "屈",
      "屋",
      "展",
      "屚",
      "属",
      "屮",
      "屯",
      "屰",
      "山",
      "岁",
      "岂",
      "岛",
      "崔",
      "崩",
      "嵒",
      "巛",
      "巜",
      "川",
      "州",
      "巟",
      "巢",
      "工",
      "左",
      "巧",
      "巨",
      "巩",
      "巫",
      "差",
      "己",
      "巳",
      "巴",
      "巷",
      "巸",
      "巽",
      "巾",
      "巿",
      "帀",
      "市",
      "布",
      "师",
      "希",
      "帛",
      "帝",
      "带",
      "干",
      "平",
      "并",
      "幺",
      "幼",
      "广",
      "庄",
      "库",
      "店",
      "府",
      "度",
      "庶",
      "康",
      "廉",
      "廴",
      "延",
      "廷",
      "建",
      "廾",
      "廿",
      "开",
      "弁",
      "弋",
      "弍",
      "式",
      "弓",
      "弔",
      "引",
      "弗",
      "弟",
      "张",
      "弯",
      "弱",
      "彐",
      "彑",
      "当",
      "录",
      "彖",
      "彗",
      "彡",
      "彦",
      "彭",
      "彳",
      "征",
      "復",
      "微",
      "心",
      "忄",
      "必",
      "忝",
      "快",
      "念",
      "思",
      "急",
      "怱",
      "总",
      "息",
      "悉",
      "惠",
      "惢",
      "感",
      "戈",
      "戉",
      "戊",
      "戋",
      "戌",
      "戎",
      "成",
      "我",
      "戒",
      "戕",
      "或",
      "戶",
      "户",
      "戸",
      "扁",
      "扇",
      "手",
      "扌",
      "才",
      "执",
      "折",
      "拉",
      "拍",
      "拜",
      "掌",
      "支",
      "攴",
      "攵",
      "收",
      "攸",
      "故",
      "敏",
      "敕",
      "敖",
      "敝",
      "敢",
      "散",
      "敦",
      "敫",
      "敬",
      "文",
      "斗",
      "斤",
      "斥",
      "斩",
      "斯",
      "新",
      "方",
      "於",
      "斿",
      "旁",
      "族",
      "无",
      "旡",
      "既",
      "日",
      "旦",
      "旨",
      "早",
      "旬",
      "旱",
      "旲",
      "昆",
      "昌",
      "明",
      "昏",
      "易",
      "昔",
      "昗",
      "昚",
      "星",
      "春",
      "昭",
      "是",
      "昷",
      "显",
      "晃",
      "普",
      "景",
      "暴",
      "曰",
      "曲",
      "曳",
      "更",
      "曷",
      "曹",
      "曼",
      "曽",
      "曾",
      "替",
      "最",
      "月",
      "有",
      "朋",
      "朔",
      "朝",
      "木",
      "朩",
      "未",
      "末",
      "本",
      "术",
      "朱",
      "朵",
      "朿",
      "杀",
      "束",
      "条",
      "来",
      "杲",
      "析",
      "林",
      "果",
      "枼",
      "某",
      "柔",
      "查",
      "柬",
      "桑",
      "桼",
      "棥",
      "樊",
      "欠",
      "次",
      "欣",
      "欶",
      "止",
      "正",
      "此",
      "步",
      "武",
      "歨",
      "歹",
      "死",
      "殳",
      "段",
      "殸",
      "殿",
      "毋",
      "毌",
      "母",
      "每",
      "比",
      "毛",
      "毳",
      "氏",
      "氐",
      "民",
      "气",
      "水",
      "氵",
      "氶",
      "永",
      "氺",
      "氾",
      "氿",
      "求",
      "汆",
      "汒",
      "江",
      "汤",
      "沓",
      "沙",
      "泉",
      "泙",
      "波",
      "洛",
      "洰",
      "活",
      "浦",
      "溥",
      "滕",
      "澡",
      "火",
      "灬",
      "灰",
      "炎",
      "炗",
      "炭",
      "烝",
      "無",
      "焦",
      "然",
      "爪",
      "爫",
      "爰",
      "爵",
      "父",
      "爻",
      "爿",
      "片",
      "牙",
      "牛",
      "牜",
      "犬",
      "犭",
      "犮",
      "犾",
      "狂",
      "玄",
      "率",
      "玉",
      "王",
      "珀",
      "瓜",
      "瓦",
      "甘",
      "甚",
      "生",
      "用",
      "甫",
      "甬",
      "田",
      "由",
      "甲",
      "申",
      "电",
      "男",
      "甹",
      "畀",
      "畄",
      "畏",
      "畐",
      "畕",
      "留",
      "畜",
      "番",
      "異",
      "畺",
      "疋",
      "疌",
      "疏",
      "疑",
      "疒",
      "疾",
      "癶",
      "癸",
      "登",
      "白",
      "百",
      "皃",
      "皆",
      "皇",
      "皮",
      "皿",
      "益",
      "盍",
      "监",
      "目",
      "直",
      "相",
      "盾",
      "眇",
      "眉",
      "真",
      "矛",
      "矞",
      "矢",
      "矣",
      "知",
      "石",
      "磨",
      "示",
      "礻",
      "祘",
      "票",
      "祭",
      "禀",
      "禁",
      "禸",
      "禹",
      "禺",
      "离",
      "禽",
      "禾",
      "秀",
      "秃",
      "秋",
      "科",
      "穴",
      "穵",
      "空",
      "窄",
      "立",
      "竟",
      "章",
      "童",
      "竹",
      "算",
      "米",
      "粦",
      "糸",
      "索",
      "累",
      "纟",
      "约",
      "缊",
      "缶",
      "罒",
      "罗",
      "罙",
      "罢",
      "署",
      "羊",
      "美",
      "羔",
      "羕",
      "羽",
      "翁",
      "翏",
      "翟",
      "老",
      "耂",
      "考",
      "者",
      "耆",
      "而",
      "耑",
      "耒",
      "耤",
      "耦",
      "耳",
      "耶",
      "聂",
      "聚",
      "聿",
      "肀",
      "肃",
      "肉",
      "肋",
      "肖",
      "肙",
      "肯",
      "肰",
      "育",
      "肴",
      "胃",
      "胡",
      "胥",
      "能",
      "臣",
      "臧",
      "自",
      "臭",
      "至",
      "臼",
      "臽",
      "臿",
      "舀",
      "舌",
      "舍",
      "舛",
      "舜",
      "舟",
      "般",
      "艮",
      "良",
      "色",
      "艹",
      "艾",
      "芇",
      "苋",
      "苗",
      "苟",
      "若",
      "茾",
      "荅",
      "荒",
      "莫",
      "萧",
      "董",
      "蒙",
      "蔺",
      "薛",
      "虍",
      "虎",
      "虑",
      "虚",
      "虫",
      "虽",
      "蚤",
      "血",
      "衣",
      "衤",
      "衮",
      "袁",
      "襄",
      "襾",
      "西",
      "覀",
      "要",
      "覃",
      "見",
      "见",
      "规",
      "览",
      "觉",
      "角",
      "觜",
      "解",
      "言",
      "訧",
      "詹",
      "讠",
      "诸",
      "谒",
      "谷",
      "豆",
      "豕",
      "豙",
      "象",
      "豪",
      "豸",
      "貌",
      "貝",
      "贝",
      "贞",
      "负",
      "贡",
      "责",
      "贯",
      "贰",
      "贱",
      "贲",
      "贵",
      "赖",
      "赤",
      "走",
      "足",
      "路",
      "身",
      "車",
      "车",
      "辇",
      "辛",
      "辟",
      "辡",
      "辰",
      "辱",
      "辶",
      "连",
      "迶",
      "迷",
      "退",
      "造",
      "逢",
      "遀",
      "遂",
      "遣",
      "那",
      "邦",
      "郎",
      "郑",
      "郭",
      "酉",
      "酋",
      "釆",
      "采",
      "里",
      "重",
      "野",
      "金",
      "钅",
      "镸",
      "长",
      "門",
      "閵",
      "门",
      "闰",
      "间",
      "闵",
      "阁",
      "阑",
      "阜",
      "阝",
      "队",
      "阴",
      "阿",
      "陏",
      "隆",
      "隐",
      "隶",
      "隹",
      "隺",
      "隽",
      "难",
      "雚",
      "雨",
      "雷",
      "需",
      "靑",
      "青",
      "非",
      "面",
      "革",
      "韦",
      "音",
      "頁",
      "页",
      "顷",
      "频",
      "颠",
      "风",
      "食",
      "饣",
      "首",
      "香",
      "馬",
      "駦",
      "马",
      "骨",
      "高",
      "髟",
      "鬲",
      "鬼",
      "魏",
      "鱼",
      "鲜",
      "鸟",
      "麻",
      "黄",
      "黑",
      "黾",
      "齐",
      "齿",
      "龙",
      "龰",
      "龱",
      "龴",
      "龶",
      "龷",
      "龹",
      "𠀐",
      "𠂇",
      "𠂉",
      "𠂊",
      "𠂎",
      "𠂑",
      "𠂔",
      "𠂤",
      "𠃊",
      "𠃌",
      "𠃓",
      "𠃜",
      "𠆧",
      "𠔏",
      "𠕁",
      "𠠵",
      "𠣜",
      "𠤕",
      "𠦝",
      "𠧒",
      "𠫔",
      "𠫝",
      "𠬝",
      "𠬤",
      "𠬶",
      "𠮛",
      "𠮦",
      "𠮷",
      "𠳋",
      "𡗗",
      "𡗜",
      "𡗞",
      "𡨄",
      "𡭴",
      "𡰪",
      "𡰯",
      "𡱒",
      "𡵂",
      "𡿺",
      "𢀖",
      "𢆉",
      "𢆶",
      "𢎥",
      "𢎨",
      "𢛳",
      "𢦏",
      "𢦑",
      "𢼄",
      "𢼸",
      "𣂑",
      "𣌢",
      "𣍢",
      "𣎆",
      "𣢟",
      "𣥂",
      "𣦼",
      "𣳾",
      "𤆛",
      "𤯝",
      "𤰔",
      "𤴓",
      "𤽄",
      "𤿺",
      "𥁕",
      "𥃭",
      "𥃲",
      "𥅛",
      "𥝢",
      "𦈢",
      "𦍌",
      "𦐇",
      "𦙲",
      "𦣞",
      "𦣻",
      "𦥔",
      "𧘇",
      "𧰨",
      "𨾴",
      "𫠣"
    ],
    "graded": [
      "⺁",
      "⺆",
      "⺈",
      "⺌",
      "⺕",
      "⺳",
      "⺽",
      "㇇",
      "㇏",
      "㐄",
      "㐆",
      "㐌",
      "㐫",
      "㐬",
      "㐭",
      "㐱",
      "㒸",
      "㓞",
      "㔾",
      "㕣",
      "㗊",
      "㝉",
      "㝴",
      "㝵",
      "㠯",
      "㡀",
      "㢆",
      "㣎",
      "㣺",
      "㫃",
      "㫗",
      "㳟",
      "㸚",
      "䍃",
      "䏍",
      "䏎",
      "䒑",
      "䖝",
      "䖵",
      "䚯",
      "䧹",
      "䩗",
      "一",
      "丁",
      "丂",
      "七",
      "丄",
      "丆",
      "万",
      "丈",
      "三",
      "上",
      "下",
      "丌",
      "不",
      "与",
      "丐",
      "丑",
      "专",
      "且",
      "丕",
      "世",
      "丘",
      "丙",
      "业",
      "丛",
      "东",
      "丝",
      "丞",
      "丢",
      "两",
      "严",
      "並",
      "丧",
      "丨",
      "丩",
      "个",
      "丫",
      "丬",
      "中",
      "丯",
      "丰",
      "串",
      "临",
      "丵",
      "丶",
      "丷",
      "丸",
      "丹",
      "为",
      "主",
      "丽",
      "举",
      "丿",
      "乁",
      "乂",
      "乃",
      "乄",
      "久",
      "乇",
      "么",
      "义",
      "之",
      "乌",
      "乍",
      "乎",
      "乏",
      "乐",
      "乑",
      "乒",
      "乓",
      "乔",
      "乖",
      "乘",
      "乙",
      "乚",
      "乛",
      "乜",
      "九",
      "乞",
      "也",
      "习",
      "乡",
      "书",
      "买",
      "乱",
      "乳",
      "亅",
      "了",
      "亇",
      "予",
      "争",
      "事",
      "二",
      "于",
      "亏",
      "云",
      "互",
      "五",
      "井",
      "亘",
      "亚",
      "些",
      "亠",
      "亡",
      "亢",
      "交",
      "亥",
      "亦",
      "产",
      "亨",
      "亩",
      "享",
      "京",
      "亭",
      "亮",
      "亲",
      "亶",
      "人",
      "亻",
      "亼",
      "亾",
      "亿",
      "什",
      "仁",
      "仅",
      "仆",
      "仇",
      "今",
      "介",
      "仌",
      "仍",
      "从",
      "仑",
      "仒",
      "仓",
      "仔",
      "他",
      "仗",
      "付",
      "仙",
      "代",
      "令",
      "以",
      "仪",
      "们",
      "仰",
      "仲",
      "件",
      "价",
      "任",
      "份",
      "仿",
      "企",
      "伊",
      "伍",
      "伏",
      "伐",
      "休",
      "众",
      "优",
      "伙",
      "会",
      "伞",
      "伟",
      "传",
      "伤",
      "伦",
      "伪",
      "伯",
      "估",
      "伴",
      "伶",
      "伸",
      "伺",
      "似",
      "但",
      "位",
      "低",
      "住",
      "佐",
      "佑",
      "体",
      "何",
      "余",
      "佛",
      "作",
      "你",
      "佣",
      "佥",
      "佩",
      "佰",
      "佳",
      "使",
      "侃",
      "侄",
      "侈",
      "例",
      "侍",
      "供",
      "依",
      "侠",
      "侣",
      "侥",
      "侦",
      "侧",
      "侨",
      "侮",
      "侯",
      "侵",
      "便",
      "促",
      "俄",
      "俊",
      "俏",
      "俐",
      "俗",
      "俘",
      "保",
      "俞",
      "信",
      "俩",
      "俭",
      "修",
      "俯",
      "俱",
      "倍",
      "倒",
      "倔",
      "倘",
      "候",
      "倚",
      "倝",
      "借",
      "倠",
      "倡",
      "倦",
      "债",
      "值",
      "倾",
      "假",
      "偏",
      "做",
      "停",
      "健",
      "偶",
      "偷",
      "偿",
      "傅",
      "傍",
      "储",
      "催",
      "傲",
      "傻",
      "像",
      "僚",
      "僧",
      "僵",
      "僻",
      "儒",
      "儿",
      "兀",
      "允",
      "元",
      "兄",
      "充",
      "兆",
      "先",
      "光",
      "克",
      "兌",
      "免",
      "兑",
      "兒",
      "兔",
      "党",
      "兜",
      "兢",
      "入",
      "全",
      "兪",
      "八",
      "公",
      "六",
      "兰",
      "共",
      "关",
      "兴",
      "兵",
      "其",
      "具",
      "典",
      "兹",
      "养",
      "兼",
      "兽",
      "冂",
      "冃",
      "冄",
      "内",
      "円",
      "冈",
      "冉",
      "冋",
      "册",
      "再",
      "冎",
      "冏",
      "冒",
      "冖",
      "冗",
      "冘",
      "写",
      "军",
      "农",
      "冠",
      "冡",
      "冤",
      "冫",
      "冬",
      "冯",
      "冰",
      "冲",
      "决",
      "况",
      "冶",
      "冷",
      "冻",
      "净",
      "凄",
      "准",
      "凉",
      "凋",
      "凌",
      "减",
      "凑",
      "凝",
      "几",
      "凡",
      "凤",
      "凧",
      "凭",
      "凯",
      "凰",
      "凳",
      "凵",
      "凶",
      "凸",
      "凹",
      "出",
      "击",
      "函",
      "凿",
      "刀",
      "刁",
      "刂",
      "刃",
      "刅",
      "分",
      "切",
      "刊",
      "刍",
      "刑",
      "划",
      "刖",
      "列",
      "刘",
      "则",
      "刚",
      "创",
      "初",
      "删",
      "判",
      "刨",
      "利",
      "别",
      "刮",
      "到",
      "制",
      "刷",
      "券",
      "刹",
      "刺",
      "刻",
      "剂",
      "剃",
      "削",
      "剌",
      "前",
      "剑",
      "剔",
      "剖",
      "剥",
      "剧",
      "剩",
      "剪",
      "副",
      "割",
      "劈",
      "力",
      "劝",
      "办",
      "功",
      "加",
      "务",
      "劣",
      "动",
      "助",
      "努",
      "劫",
      "励",
      "劲",
      "劳",
      "势",
      "勃",
      "勇",
      "勉",
      "勋",
      "勒",
      "勘",
      "募",
      "勤",
      "勹",
      "勺",
      "勾",
      "勿",
      "匀",
      "匃",
      "包",
      "匆",
      "匈",
      "匊",
      "匋",
      "匍",
      "匕",
      "化",
      "北",
      "匙",
      "匚",
      "匝",
      "匠",
      "匡",
      "匪",
      "匹",
      "区",
      "医",
      "匽",
      "匿",
      "十",
      "卂",
      "千",
      "卅",
      "升",
      "午",
      "卉",
      "半",
      "华",
      "协",
      "卑",
      "卒",
      "卓",
      "单",
      "卖",
      "南",
      "単",
      "博",
      "卜",
      "占",
      "卡",
      "卤",
      "卦",
      "卧",
      "卩",
      "卪",
      "卫",
      "卬",
      "卯",
      "印",
      "危",
      "即",
      "却",
      "卵",
      "卷",
      "卸",
      "厂",
      "厃",
      "厄",
      "厅",
      "历",
      "厈",
      "厉",
      "压",
      "厌",
      "厓",
      "厕",
      "厘",
      "厚",
      "原",
      "厢",
      "厦",
      "厨",
      "厶",
      "厷",
      "去",
      "厽",
      "县",
      "叀",
      "参",
      "又",
      "叉",
      "及",
      "友",
      "双",
      "反",
      "収",
      "叐",
      "发",
      "叒",
      "叔",
      "叕",
      "取",
      "受",
      "变",
      "叙",
      "叚",
      "叛",
      "叟",
      "叠",
      "口",
      "古",
      "句",
      "另",
      "叨",
      "叩",
      "只",
      "叫",
      "召",
      "叭",
      "叮",
      "可",
      "台",
      "史",
      "右",
      "叶",
      "号",
      "司",
      "叹",
      "叼",
      "吁",
      "吂",
      "吃",
      "各",
      "合",
      "吉",
      "吊",
      "同",
      "名",
      "后",
      "吏",
      "吐",
      "向",
      "吓",
      "吕",
      "吗",
      "君",
      "吝",
      "吞",
      "吟",
      "否",
      "吧",
      "吨",
      "吩",
      "含",
      "听",
      "吭",
      "启",
      "吴",
      "吵",
      "吸",
      "吹",
      "吻",
      "吼",
      "吾",
      "呀",
      "呆",
      "呈",
      "告",
      "呐",
      "呕",
      "员",
      "呙",
      "呛",
      "呜",
      "呢",
      "周",
      "味",
      "呵",
      "呻",
      "呼",
      "命",
      "咀",
      "咅",
      "咋",
      "和",
      "咏",
      "咐",
      "咕",
      "咖",
      "咙",
      "咠",
      "咢",
      "咧",
      "咨",
      "咬",
      "咱",
      "咳",
      "咸",
      "咽",
      "哀",
      "品",
      "哄",
      "哆",
      "哇",
      "哈",
      "响",
      "哎",
      "哑",
      "哗",
      "哥",
      "哦",
      "哨",
      "哪",
      "哭",
      "哲",
      "哺",
      "哼",
      "哽",
      "唆",
      "唇",
      "唉",
      "唐",
      "唠",
      "唤",
      "唬",
      "售",
      "唯",
      "唱",
      "唾",
      "啃",
      "商",
      "啇",
      "啊",
      "啚",
      "啡",
      "啤",
      "啥",
      "啦",
      "啬",
      "啰",
      "啸",
      "喂",
      "善",
      "喇",
      "喉",
      "喊",
      "喘",
      "喜",
      "喝",
      "喧",
      "喷",
      "喻",
      "喿",
      "嗅",
      "嗓",
      "嗜",
      "嗦",
      "嗨",
      "嗯",
      "嗽",
      "嘀",
      "嘈",
      "嘉",
      "嘛",
      "嘱",
      "嘲",
      "嘴",
      "嘿",
      "器",
      "噩",
      "噪",
      "嚏",
      "嚣",
      "嚷",
      "嚼",
      "囊",
      "囗",
      "囚",
      "四",
      "回",
      "囟",
      "因",
      "团",
      "园",
      "困",
      "囱",
      "围",
      "囷",
      "固",
      "国",
      "图",
      "圆",
      "圈",
      "土",
      "圡",
      "圣",
      "圤",
      "圥",
      "在",
      "圭",
      "地",
      "场",
      "圼",
      "圾",
      "址",
      "均",
      "坊",
      "坎",
      "坏",
      "坐",
      "坑",
      "块",
      "坚",
      "坛",
      "坝",
      "坟",
      "坠",
      "坡",
      "坦",
      "坪",
      "坴",
      "坷",
      "垂",
      "垃",
      "垄",
      "型",
      "垒",
      "垦",
      "垫",
      "垮",
      "埋",
      "城",
      "域",
      "培",
      "基",
      "堂",
      "堆",
      "堇",
      "堕",
      "堡",
      "堤",
      "堪",
      "堵",
      "塌",
      "塑",
      "塔",
      "塘",
      "塞",
      "填",
      "境",
      "墅",
      "墓",
      "墙",
      "增",
      "墟",
      "墨",
      "壁",
      "壤",
      "士",
      "壬",
      "壮",
      "声",
      "壳",
      "壴",
      "壶",
      "夂",
      "夃",
      "处",
      "夅",
      "夆",
      "备",
      "夋",
      "夌",
      "复",
      "夏",
      "夓",
      "夕",
      "外",
      "夗",
      "多",
      "夜",
      "够",
      "大",
      "天",
      "太",
      "夫",
      "夬",
      "夭",
      "央",
      "夯",
      "夰",
      "失",
      "头",
      "夷",
      "夸",
      "夹",
      "夺",
      "奂",
      "奄",
      "奇",
      "奈",
      "奉",
      "奋",
      "奏",
      "契",
      "奔",
      "奖",
      "套",
      "奚",
      "奠",
      "奢",
      "奥",
      "奧",
      "女",
      "奴",
      "奶",
      "奸",
      "她",
      "好",
      "如",
      "妄",
      "妆",
      "妇",
      "妈",
      "妒",
      "妖",
      "妙",
      "妟",
      "妥",
      "妨",
      "妹",
      "妻",
      "妾",
      "姆",
      "始",
      "姐",
      "姑",
      "姓",
      "委",
      "姜",
      "姥",
      "姨",
      "姻",
      "姿",
      "威",
      "娃",
      "娄",
      "娇",
      "娘",
      "娥",
      "娱",
      "娶",
      "婆",
      "婉",
      "婚",
      "婪",
      "婴",
      "婿",
      "媒",
      "媚",
      "媲",
      "媳",
      "嫁",
      "嫂",
      "嫉",
      "嫌",
      "嫦",
      "嫩",
      "嬉",
      "子",
      "孔",
      "孕",
      "字",
      "存",
      "孙",
      "孚",
      "孛",
      "孝",
      "孟",
      "季",
      "孤",
      "学",
      "孩",
      "孪",
      "孰",
      "孵",
      "宀",
      "宁",
      "它",
      "宅",
      "宇",
      "守",
      "安",
      "宋",
      "完",
      "宏",
      "宓",
      "宗",
      "官",
      "宙",
      "定",
      "宛",
      "宜",
      "宝",
      "实",
      "宠",
      "审",
      "客",
      "宣",
      "室",
      "宩",
      "宪",
      "宫",
      "宰",
      "害",
      "宴",
      "宵",
      "家",
      "宷",
      "容",
      "宽",
      "宾",
      "宿",
      "寂",
      "寄",
      "寅",
      "密",
      "富",
      "寐",
      "寒",
      "寓",
      "寝",
      "寞",
      "察",
      "寡",
      "寥",
      "寨",
      "寸",
      "对",
      "寺",
      "寻",
      "导",
      "寿",
      "封",
      "尃",
      "射",
      "将",
      "尉",
      "尊",
      "小",
      "少",
      "尔",
      "尖",
      "尗",
      "尘",
      "尚",
      "尝",
      "尞",
      "尢",
      "尤",
      "尧",
      "尬",
      "就",
      "尴",
      "尸",
      "尹",
      "尺",
      "尼",
      "尽",
      "尾",
      "尿",
      "局",
      "屁",
      "层",
      "居",
      "屈",
      "屉",
      "届",
      "屋",
      "屎",
      "屏",
      "屑",
      "展",
      "屚",
      "属",
      "屠",
      "屡",
      "履",
      "屮",
      "屯",
      "屰",
      "山",
      "屹",
      "屿",
      "岁",
      "岂",
      "岔",
      "岖",
      "岗",
      "岛",
      "岩",
      "岭",
      "岳",
      "岸",
      "峙",
      "峡",
      "峭",
      "峰",
      "峻",
      "崇",
      "崎",
      "崔",
      "崖",
      "崛",
      "崩",
      "崭",
      "嵌",
      "嵒",
      "巅",
      "巛",
      "巜",
      "川",
      "州",
      "巟",
      "巡",
      "巢",
      "工",
      "左",
      "巧",
      "巨",
      "巩",
      "巫",
      "差",
      "己",
      "已",
      "巳",
      "巴",
      "巷",
      "巸",
      "巽",
      "巾",
      "巿",
      "帀",
      "币",
      "市",
      "布",
      "帅",
      "帆",
      "师",
      "希",
      "帐",
      "帕",
      "帖",
      "帘",
      "帚",
      "帛",
      "帜",
      "帝",
      "带",
      "席",
      "帮",
      "帷",
      "常",
      "帽",
      "幄",
      "幅",
      "幕",
      "幢",
      "干",
      "平",
      "年",
      "并",
      "幸",
      "幺",
      "幻",
      "幼",
      "幽",
      "广",
      "庄",
      "庆",
      "庇",
      "床",
      "序",
      "库",
      "应",
      "底",
      "店",
      "庙",
      "府",
      "庞",
      "废",
      "度",
      "座",
      "庭",
      "庶",
      "康",
      "庸",
      "廉",
      "廊",
      "廓",
      "廴",
      "延",
      "廷",
      "建",
      "廾",
      "廿",
      "开",
      "弁",
      "异",
      "弃",
      "弄",
      "弈",
      "弊",
      "弋",
      "弍",
      "式",
      "弓",
      "弔",
      "引",
      "弗",
      "弘",
      "弛",
      "弟",
      "张",
      "弥",
      "弦",
      "弧",
      "弯",
      "弱",
      "弹",
      "强",
      "彐",
      "彑",
      "归",
      "当",
      "录",
      "彖",
      "彗",
      "彡",
      "形",
      "彦",
      "彩",
      "彬",
      "彭",
      "彰",
      "影",
      "彳",
      "役",
      "彻",
      "彼",
      "往",
      "征",
      "径",
      "待",
      "很",
      "徊",
      "律",
      "徐",
      "徒",
      "得",
      "徘",
      "徙",
      "御",
      "復",
      "循",
      "微",
      "德",
      "徽",
      "心",
      "忄",
      "必",
      "忆",
      "忌",
      "忍",
      "志",
      "忘",
      "忙",
      "忝",
      "忠",
      "忧",
      "快",
      "念",
      "忽",
      "怀",
      "态",
      "怂",
      "怎",
      "怒",
      "怕",
      "怖",
      "怜",
      "思",
      "怠",
      "怡",
      "急",
      "性",
      "怨",
      "怪",
      "怯",
      "怱",
      "总",
      "恋",
      "恍",
      "恐",
      "恒",
      "恕",
      "恢",
      "恤",
      "恨",
      "恩",
      "恭",
      "息",
      "恰",
      "恳",
      "恶",
      "恼",
      "恿",
      "悄",
      "悉",
      "悔",
      "悟",
      "悠",
      "患",
      "悦",
      "您",
      "悬",
      "悲",
      "悴",
      "悼",
      "情",
      "惊",
      "惋",
      "惑",
      "惕",
      "惜",
      "惠",
      "惦",
      "惧",
      "惨",
      "惩",
      "惫",
      "惬",
      "惭",
      "惮",
      "惯",
      "惰",
      "想",
      "惹",
      "愁",
      "愈",
      "愉",
      "意",
      "愚",
      "感",
      "愣",
      "愤",
      "愧",
      "愿",
      "慈",
      "慌",
      "慎",
      "慑",
      "慕",
      "慢",
      "慧",
      "慨",
      "慰",
      "慷",
      "憋",
      "憔",
      "憧",
      "憨",
      "憬",
      "憾",
      "懂",
      "懈",
      "懒",
      "戈",
      "戉",
      "戊",
      "戋",
      "戌",
      "戎",
      "戏",
      "成",
      "我",
      "戒",
      "戕",
      "或",
      "战",
      "戚",
      "截",
      "戳",
      "戴",
      "戶",
      "户",
      "戸",
      "房",
      "所",
      "扁",
      "扇",
      "手",
      "扌",
      "才",
      "扎",
      "扑",
      "扒",
      "打",
      "扔",
      "托",
      "扛",
      "扣",
      "执",
      "扩",
      "扫",
      "扬",
      "扭",
      "扮",
      "扯",
      "扰",
      "扳",
      "扶",
      "批",
      "找",
      "承",
      "技",
      "抄",
      "抉",
      "把",
      "抑",
      "抒",
      "抓",
      "投",
      "抖",
      "抗",
      "折",
      "抚",
      "抛",
      "抠",
      "抡",
      "抢",
      "护",
      "报",
      "抨",
      "披",
      "抬",
      "抱",
      "抵",
      "抹",
      "押",
      "抽",
      "拄",
      "担",
      "拆",
      "拇",
      "拉",
      "拌",
      "拍",
      "拎",
      "拐",
      "拒",
      "拓",
      "拔",
      "拖",
      "拘",
      "拙",
      "招",
      "拜",
      "拟",
      "拢",
      "拣",
      "拥",
      "拦",
      "拧",
      "拨",
      "择",
      "括",
      "拯",
      "拱",
      "拳",
      "拴",
      "拼",
      "拽",
      "拾",
      "拿",
      "持",
      "挂",
      "指",
      "按",
      "挎",
      "挑",
      "挖",
      "挚",
      "挟",
      "挠",
      "挡",
      "挣",
      "挤",
      "挥",
      "挨",
      "挪",
      "挫",
      "振",
      "挺",
      "挽",
      "捂",
      "捅",
      "捆",
      "捉",
      "捍",
      "捎",
      "捏",
      "捐",
      "捕",
      "捞",
      "损",
      "捡",
      "换",
      "捣",
      "捧",
      "据",
      "捶",
      "捷",
      "掀",
      "授",
      "掉",
      "掌",
      "掏",
      "掐",
      "排",
      "掘",
      "掠",
      "探",
      "接",
      "控",
      "推",
      "掩",
      "措",
      "掰",
      "掷",
      "掺",
      "揉",
      "揍",
      "描",
      "提",
      "插",
      "揠",
      "握",
      "揣",
      "揪",
      "揭",
      "援",
      "揽",
      "搀",
      "搁",
      "搂",
      "搅",
      "搏",
      "搓",
      "搜",
      "搞",
      "搬",
      "搭",
      "携",
      "摄",
      "摆",
      "摇",
      "摊",
      "摔",
      "摘",
      "摧",
      "摩",
      "摸",
      "撇",
      "撑",
      "撒",
      "撕",
      "撞",
      "撤",
      "撬",
      "播",
      "撰",
      "撵",
      "撼",
      "擅",
      "操",
      "擎",
      "擦",
      "攀",
      "攒",
      "攘",
      "支",
      "攴",
      "攵",
      "收",
      "攸",
      "改",
      "攻",
      "放",
      "政",
      "故",
      "效",
      "敌",
      "敏",
      "救",
      "敕",
      "敖",
      "教",
      "敛",
      "敝",
      "敞",
      "敢",
      "散",
      "敦",
      "敫",
      "敬",
      "数",
      "敲",
      "整",
      "敷",
      "文",
      "斑",
      "斗",
      "料",
      "斜",
      "斟",
      "斤",
      "斥",
      "斧",
      "斩",
      "断",
      "斯",
      "新",
      "方",
      "於",
      "施",
      "斿",
      "旁",
      "旅",
      "旋",
      "族",
      "旗",
      "无",
      "旡",
      "既",
      "日",
      "旦",
      "旧",
      "旨",
      "早",
      "旬",
      "旭",
      "旱",
      "旲",
      "时",
      "旷",
      "旺",
      "昂",
      "昆",
      "昌",
      "明",
      "昏",
      "易",
      "昔",
      "昚",
      "星",
      "映",
      "春",
      "昧",
      "昨",
      "昭",
      "是",
      "昷",
      "昼",
      "显",
      "晃",
      "晋",
      "晒",
      "晓",
      "晕",
      "晚",
      "晤",
      "晨",
      "普",
      "景",
      "晰",
      "晴",
      "晶",
      "智",
      "晾",
      "暂",
      "暄",
      "暑",
      "暖",
      "暗",
      "暧",
      "暨",
      "暮",
      "暴",
      "曙",
      "曝",
      "曰",
      "曲",
      "曳",
      "更",
      "曷",
      "曹",
      "曼",
      "曽",
      "曾",
      "替",
      "最",
      "月",
      "有",
      "朋",
      "服",
      "朔",
      "朗",
      "望",
      "朝",
      "期",
      "朦",
      "木",
      "朩",
      "未",
      "末",
      "本",
      "术",
      "朱",
      "朴",
      "朵",
      "机",
      "朽",
      "朿",
      "杀",
      "杂",
      "权",
      "杆",
      "李",
      "材",
      "村",
      "杖",
      "杜",
      "束",
      "杠",
      "条",
      "来",
      "杨",
      "杭",
      "杯",
      "杰",
      "杲",
      "松",
      "板",
      "极",
      "构",
      "枉",
      "析",
      "枕",
      "林",
      "枚",
      "果",
      "枝",
      "枢",
      "枣",
      "枪",
      "枯",
      "架",
      "枼",
      "柄",
      "柏",
      "某",
      "染",
      "柔",
      "柜",
      "查",
      "柬",
      "柱",
      "柳",
      "柴",
      "柿",
      "标",
      "栋",
      "栏",
      "树",
      "栓",
      "栖",
      "校",
      "株",
      "样",
      "核",
      "根",
      "格",
      "栽",
      "桂",
      "桃",
      "框",
      "案",
      "桌",
      "桑",
      "桔",
      "档",
      "桥",
      "桨",
      "桩",
      "桶",
      "桼",
      "梁",
      "梅",
      "梢",
      "梦",
      "梨",
      "梭",
      "梯",
      "械",
      "梳",
      "检",
      "棉",
      "棋",
      "棍",
      "棒",
      "棕",
      "棘",
      "棚",
      "棥",
      "森",
      "棱",
      "棵",
      "棺",
      "椅",
      "植",
      "椎",
      "椒",
      "椭",
      "椰",
      "楚",
      "楷",
      "楼",
      "概",
      "榜",
      "榨",
      "槐",
      "槛",
      "槽",
      "樊",
      "模",
      "横",
      "橘",
      "橙",
      "橡",
      "橱",
      "檐",
      "欠",
      "次",
      "欢",
      "欣",
      "欧",
      "欲",
      "欶",
      "欺",
      "款",
      "歇",
      "歉",
      "歌",
      "止",
      "正",
      "此",
      "步",
      "武",
      "歧",
      "歨",
      "歪",
      "歹",
      "死",
      "歼",
      "殃",
      "殊",
      "残",
      "殖",
      "殳",
      "殴",
      "段",
      "殷",
      "殸",
      "殿",
      "毁",
      "毅",
      "毋",
      "毌",
      "母",
      "每",
      "毒",
      "比",
      "毕",
      "毙",
      "毛",
      "毫",
      "毯",
      "毳",
      "氏",
      "氐",
      "民",
      "氓",
      "气",
      "氛",
      "氧",
      "水",
      "氵",
      "氶",
      "永",
      "氺",
      "氾",
      "氿",
      "汁",
      "求",
      "汆",
      "汇",
      "汉",
      "汒",
      "汗",
      "汛",
      "江",
      "池",
      "污",
      "汤",
      "汪",
      "汰",
      "汲",
      "汹",
      "汽",
      "沃",
      "沉",
      "沏",
      "沐",
      "沓",
      "沙",
      "沛",
      "沟",
      "没",
      "沧",
      "沪",
      "沫",
      "沮",
      "河",
      "沸",
      "油",
      "治",
      "沼",
      "沽",
      "沾",
      "沿",
      "泄",
      "泉",
      "泊",
      "泌",
      "法",
      "泙",
      "泛",
      "泞",
      "泡",
      "波",
      "泣",
      "泥",
      "注",
      "泪",
      "泰",
      "泳",
      "泻",
      "泼",
      "泽",
      "洁",
      "洋",
      "洒",
      "洗",
      "洛",
      "洞",
      "津",
      "洪",
      "洰",
      "洲",
      "活",
      "洽",
      "派",
      "流",
      "浅",
      "浆",
      "浇",
      "浊",
      "测",
      "济",
      "浏",
      "浑",
      "浓",
      "浙",
      "浦",
      "浩",
      "浪",
      "浮",
      "浴",
      "海",
      "浸",
      "涂",
      "消",
      "涉",
      "涌",
      "涕",
      "涛",
      "涝",
      "涡",
      "涤",
      "润",
      "涨",
      "涩",
      "涮",
      "涯",
      "液",
      "涵",
      "淀",
      "淆",
      "淋",
      "淌",
      "淘",
      "淡",
      "淤",
      "淮",
      "深",
      "淳",
      "混",
      "淹",
      "添",
      "清",
      "渊",
      "渐",
      "渔",
      "渗",
      "渝",
      "渠",
      "渡",
      "渣",
      "温",
      "港",
      "渴",
      "游",
      "渺",
      "湃",
      "湖",
      "湛",
      "湾",
      "湿",
      "溃",
      "溅",
      "溉",
      "源",
      "溜",
      "溢",
      "溥",
      "溪",
      "溯",
      "溶",
      "溺",
      "滋",
      "滑",
      "滔",
      "滕",
      "滚",
      "滞",
      "满",
      "滤",
      "滥",
      "滨",
      "滩",
      "滴",
      "漂",
      "漆",
      "漏",
      "演",
      "漠",
      "漫",
      "漱",
      "漾",
      "潇",
      "潘",
      "潜",
      "潦",
      "潭",
      "潮",
      "澄",
      "澈",
      "澎",
      "澜",
      "澡",
      "澳",
      "激",
      "濒",
      "瀑",
      "瀚",
      "灌",
      "火",
      "灬",
      "灭",
      "灯",
      "灰",
      "灵",
      "灶",
      "灸",
      "灼",
      "灾",
      "灿",
      "炉",
      "炊",
      "炎",
      "炒",
      "炖",
      "炗",
      "炫",
      "炬",
      "炭",
      "炮",
      "炸",
      "点",
      "炼",
      "烁",
      "烂",
      "烈",
      "烘",
      "烛",
      "烝",
      "烟",
      "烤",
      "烦",
      "烧",
      "烫",
      "热",
      "烹",
      "焊",
      "焕",
      "焙",
      "焚",
      "無",
      "焦",
      "焰",
      "然",
      "煌",
      "煎",
      "煤",
      "照",
      "煮",
      "煲",
      "煽",
      "熄",
      "熊",
      "熏",
      "熙",
      "熟",
      "熨",
      "熬",
      "燃",
      "燕",
      "燥",
      "爆",
      "爪",
      "爫",
      "爬",
      "爰",
      "爱",
      "爵",
      "父",
      "爷",
      "爸",
      "爹",
      "爻",
      "爽",
      "爿",
      "片",
      "版",
      "牌",
      "牙",
      "牛",
      "牜",
      "牡",
      "牢",
      "牧",
      "物",
      "牲",
      "牵",
      "特",
      "牺",
      "犀",
      "犬",
      "犭",
      "犮",
      "犯",
      "状",
      "犹",
      "犾",
      "狂",
      "狈",
      "狐",
      "狗",
      "狠",
      "狡",
      "独",
      "狭",
      "狮",
      "狱",
      "狸",
      "狼",
      "猋",
      "猎",
      "猖",
      "猛",
      "猜",
      "猩",
      "猪",
      "猫",
      "献",
      "猴",
      "猾",
      "玄",
      "率",
      "玉",
      "王",
      "玩",
      "玫",
      "环",
      "现",
      "玻",
      "珀",
      "珍",
      "珠",
      "班",
      "球",
      "理",
      "琐",
      "琢",
      "琴",
      "瑕",
      "瑞",
      "瑰",
      "璀",
      "璃",
      "璨",
      "瓜",
      "瓣",
      "瓦",
      "瓶",
      "瓷",
      "甘",
      "甚",
      "甜",
      "生",
      "甥",
      "用",
      "甩",
      "甫",
      "甬",
      "甭",
      "田",
      "由",
      "甲",
      "申",
      "电",
      "男",
      "甸",
      "甹",
      "画",
      "畀",
      "畄",
      "畅",
      "界",
      "畏",
      "畐",
      "畔",
      "畕",
      "留",
      "畜",
      "略",
      "番",
      "異",
      "畴",
      "畸",
      "畺",
      "疆",
      "疋",
      "疌",
      "疏",
      "疐",
      "疑",
      "疒",
      "疗",
      "疙",
      "疤",
      "疫",
      "疯",
      "疲",
      "疵",
      "疼",
      "疾",
      "病",
      "症",
      "痒",
      "痕",
      "痛",
      "痪",
      "痰",
      "痴",
      "痹",
      "瘟",
      "瘤",
      "瘦",
      "瘩",
      "瘫",
      "瘸",
      "瘾",
      "癌",
      "癶",
      "登",
      "白",
      "百",
      "皂",
      "皃",
      "的",
      "皆",
      "皇",
      "皮",
      "皱",
      "皿",
      "盆",
      "盈",
      "益",
      "盍",
      "盏",
      "盐",
      "监",
      "盒",
      "盖",
      "盗",
      "盘",
      "盛",
      "盟",
      "目",
      "盯",
      "盲",
      "直",
      "相",
      "盹",
      "盼",
      "盾",
      "省",
      "眇",
      "眉",
      "看",
      "真",
      "眠",
      "眨",
      "眯",
      "眶",
      "眺",
      "眼",
      "着",
      "睁",
      "睐",
      "睛",
      "睡",
      "督",
      "睦",
      "睬",
      "睹",
      "瞄",
      "瞅",
      "瞎",
      "瞒",
      "瞧",
      "瞩",
      "瞪",
      "瞬",
      "瞻",
      "矗",
      "矛",
      "矞",
      "矢",
      "矣",
      "知",
      "矩",
      "矫",
      "短",
      "矮",
      "石",
      "矿",
      "码",
      "砂",
      "砌",
      "砍",
      "研",
      "砖",
      "破",
      "砸",
      "础",
      "硕",
      "硬",
      "确",
      "碌",
      "碍",
      "碎",
      "碑",
      "碗",
      "碟",
      "碧",
      "碰",
      "碳",
      "磁",
      "磅",
      "磊",
      "磋",
      "磕",
      "磨",
      "礁",
      "示",
      "礻",
      "礼",
      "社",
      "祀",
      "祈",
      "祖",
      "祘",
      "祝",
      "神",
      "祥",
      "票",
      "祭",
      "祷",
      "祸",
      "禁",
      "禅",
      "福",
      "禸",
      "禹",
      "禺",
      "离",
      "禽",
      "禾",
      "秀",
      "私",
      "秃",
      "秉",
      "秋",
      "种",
      "科",
      "秒",
      "秘",
      "租",
      "秤",
      "秦",
      "秧",
      "秩",
      "积",
      "称",
      "移",
      "秽",
      "稀",
      "程",
      "稍",
      "税",
      "稚",
      "稠",
      "稳",
      "稻",
      "稼",
      "稽",
      "稿",
      "穆",
      "穴",
      "穵",
      "究",
      "穷",
      "空",
      "穿",
      "突",
      "窃",
      "窄",
      "窍",
      "窑",
      "窒",
      "窗",
      "窘",
      "窜",
      "窝",
      "窟",
      "窥",
      "窿",
      "立",
      "竖",
      "站",
      "竞",
      "竟",
      "章",
      "竣",
      "童",
      "竭",
      "端",
      "竹",
      "竿",
      "笑",
      "笔",
      "笛",
      "符",
      "笨",
      "第",
      "笼",
      "等",
      "筋",
      "筐",
      "筑",
      "筒",
      "答",
      "策",
      "筛",
      "筝",
      "筷",
      "筹",
      "签",
      "简",
      "算",
      "管",
      "箭",
      "箱",
      "篇",
      "篮",
      "篷",
      "簇",
      "簸",
      "籍",
      "米",
      "类",
      "籽",
      "粉",
      "粒",
      "粕",
      "粗",
      "粘",
      "粤",
      "粥",
      "粦",
      "粪",
      "粮",
      "粲",
      "粹",
      "粽",
      "精",
      "糊",
      "糕",
      "糖",
      "糙",
      "糟",
      "糸",
      "系",
      "紊",
      "素",
      "索",
      "紧",
      "紫",
      "累",
      "絮",
      "繁",
      "纟",
      "纠",
      "红",
      "纤",
      "约",
      "级",
      "纪",
      "纬",
      "纯",
      "纱",
      "纲",
      "纳",
      "纵",
      "纷",
      "纸",
      "纹",
      "纺",
      "纽",
      "线",
      "练",
      "组",
      "绅",
      "细",
      "织",
      "终",
      "绊",
      "绍",
      "绎",
      "经",
      "绑",
      "绒",
      "结",
      "绕",
      "绘",
      "给",
      "络",
      "绝",
      "绞",
      "统",
      "绣",
      "继",
      "绩",
      "绪",
      "续",
      "绯",
      "绰",
      "绳",
      "维",
      "绵",
      "绷",
      "绸",
      "综",
      "绽",
      "绿",
      "缀",
      "缅",
      "缆",
      "缉",
      "缊",
      "缓",
      "缔",
      "缕",
      "编",
      "缘",
      "缚",
      "缝",
      "缠",
      "缤",
      "缩",
      "缴",
      "缶",
      "缸",
      "缺",
      "罐",
      "网",
      "罒",
      "罕",
      "罗",
      "罙",
      "罚",
      "罢",
      "罩",
      "罪",
      "置",
      "署",
      "羊",
      "美",
      "羔",
      "羕",
      "羞",
      "羡",
      "群",
      "羽",
      "翁",
      "翅",
      "翏",
      "翔",
      "翘",
      "翟",
      "翠",
      "翰",
      "翻",
      "翼",
      "耀",
      "老",
      "耂",
      "考",
      "者",
      "耆",
      "而",
      "耍",
      "耐",
      "耑",
      "耒",
      "耕",
      "耗",
      "耘",
      "耤",
      "耳",
      "耶",
      "耸",
      "耻",
      "耽",
      "耿",
      "聂",
      "聆",
      "聊",
      "聋",
      "职",
      "联",
      "聘",
      "聚",
      "聪",
      "聿",
      "肀",
      "肃",
      "肆",
      "肇",
      "肉",
      "肋",
      "肌",
      "肖",
      "肙",
      "肚",
      "肝",
      "肠",
      "股",
      "肢",
      "肤",
      "肥",
      "肩",
      "肪",
      "肯",
      "肰",
      "育",
      "肴",
      "肺",
      "肾",
      "肿",
      "胀",
      "胁",
      "胃",
      "胆",
      "背",
      "胎",
      "胖",
      "胚",
      "胜",
      "胞",
      "胡",
      "胥",
      "胧",
      "胳",
      "胶",
      "胸",
      "能",
      "脂",
      "脆",
      "脉",
      "脊",
      "脏",
      "脑",
      "脖",
      "脚",
      "脱",
      "脸",
      "脾",
      "腆",
      "腊",
      "腐",
      "腔",
      "腕",
      "腥",
      "腰",
      "腹",
      "腺",
      "腻",
      "腼",
      "腾",
      "腿",
      "膀",
      "膊",
      "膏",
      "膛",
      "膜",
      "膝",
      "膨",
      "膳",
      "臀",
      "臂",
      "臊",
      "臣",
      "臧",
      "自",
      "臭",
      "至",
      "致",
      "臼",
      "臽",
      "臿",
      "舀",
      "舅",
      "舆",
      "舌",
      "舍",
      "舒",
      "舔",
      "舛",
      "舜",
      "舞",
      "舟",
      "航",
      "般",
      "舰",
      "舱",
      "舵",
      "舶",
      "船",
      "艇",
      "艘",
      "艮",
      "良",
      "艰",
      "色",
      "艳",
      "艹",
      "艺",
      "艾",
      "节",
      "芇",
      "芒",
      "芝",
      "芦",
      "芬",
      "芭",
      "芯",
      "花",
      "芳",
      "芽",
      "苋",
      "苍",
      "苏",
      "苗",
      "苛",
      "苟",
      "若",
      "苦",
      "英",
      "苹",
      "茁",
      "茂",
      "范",
      "茄",
      "茅",
      "茉",
      "茎",
      "茫",
      "茶",
      "茾",
      "荅",
      "荆",
      "草",
      "荐",
      "荒",
      "荡",
      "荣",
      "荤",
      "荧",
      "荫",
      "药",
      "荷",
      "莅",
      "莉",
      "莫",
      "莲",
      "获",
      "莹",
      "莽",
      "菇",
      "菊",
      "菌",
      "菜",
      "菩",
      "萄",
      "萌",
      "萍",
      "萎",
      "萝",
      "营",
      "萧",
      "萨",
      "落",
      "著",
      "葡",
      "董",
      "葬",
      "葱",
      "蒂",
      "蒙",
      "蒜",
      "蒸",
      "蓄",
      "蓝",
      "蓬",
      "蔑",
      "蔓",
      "蔚",
      "蔬",
      "蔼",
      "蔽",
      "蕉",
      "蕴",
      "蕾",
      "薄",
      "薪",
      "薯",
      "藏",
      "藐",
      "藤",
      "藻",
      "蘑",
      "蘸",
      "虍",
      "虎",
      "虏",
      "虐",
      "虑",
      "虔",
      "虚",
      "虫",
      "虹",
      "虽",
      "虾",
      "蚀",
      "蚁",
      "蚂",
      "蚊",
      "蚤",
      "蛀",
      "蛇",
      "蛋",
      "蛙",
      "蛮",
      "蜀",
      "蜂",
      "蜜",
      "蜡",
      "蝇",
      "蝴",
      "蝶",
      "螃",
      "融",
      "螺",
      "蟹",
      "蠢",
      "血",
      "衅",
      "行",
      "衍",
      "衔",
      "街",
      "衡",
      "衣",
      "衤",
      "补",
      "表",
      "衫",
      "衬",
      "衮",
      "衰",
      "衷",
      "袁",
      "袋",
      "袍",
      "袖",
      "袜",
      "被",
      "袭",
      "袱",
      "裁",
      "裂",
      "装",
      "裔",
      "裕",
      "裙",
      "裤",
      "裳",
      "裸",
      "裹",
      "褒",
      "襄",
      "襾",
      "西",
      "覀",
      "要",
      "覃",
      "覆",
      "見",
      "见",
      "观",
      "规",
      "觅",
      "视",
      "览",
      "觉",
      "角",
      "觜",
      "解",
      "触",
      "言",
      "訧",
      "詹",
      "誉",
      "誓",
      "警",
      "譬",
      "讠",
      "计",
      "订",
      "认",
      "讥",
      "讨",
      "让",
      "训",
      "议",
      "讯",
      "记",
      "讲",
      "讳",
      "讶",
      "许",
      "讹",
      "论",
      "讼",
      "讽",
      "设",
      "访",
      "诀",
      "证",
      "评",
      "识",
      "诈",
      "诉",
      "诊",
      "词",
      "译",
      "试",
      "诗",
      "诚",
      "话",
      "诞",
      "诠",
      "诡",
      "询",
      "该",
      "详",
      "诧",
      "诫",
      "诬",
      "语",
      "误",
      "诱",
      "说",
      "诵",
      "请",
      "诸",
      "诺",
      "读",
      "诽",
      "课",
      "谁",
      "调",
      "谅",
      "谈",
      "谊",
      "谋",
      "谍",
      "谎",
      "谐",
      "谒",
      "谓",
      "谜",
      "谢",
      "谣",
      "谤",
      "谦",
      "谨",
      "谬",
      "谱",
      "谴",
      "谷",
      "豁",
      "豆",
      "豕",
      "豙",
      "豚",
      "象",
      "豪",
      "豫",
      "豸",
      "豹",
      "貌",
      "貝",
      "贝",
      "贞",
      "负",
      "贡",
      "财",
      "责",
      "贤",
      "败",
      "账",
      "货",
      "质",
      "贩",
      "贪",
      "贫",
      "贬",
      "购",
      "贮",
      "贯",
      "贰",
      "贱",
      "贲",
      "贴",
      "贵",
      "贷",
      "贸",
      "费",
      "贺",
      "贼",
      "贾",
      "贿",
      "赁",
      "赂",
      "赃",
      "资",
      "赋",
      "赌",
      "赎",
      "赏",
      "赐",
      "赔",
      "赖",
      "赘",
      "赚",
      "赛",
      "赞",
      "赠",
      "赡",
      "赢",
      "赤",
      "赫",
      "走",
      "赴",
      "赵",
      "赶",
      "起",
      "趁",
      "超",
      "越",
      "趋",
      "趟",
      "趣",
      "足",
      "趴",
      "跃",
      "跌",
      "跑",
      "距",
      "跟",
      "跤",
      "跨",
      "跪",
      "路",
      "跳",
      "践",
      "跷",
      "踊",
      "踏",
      "踢",
      "踩",
      "踪",
      "踹",
      "蹈",
      "蹊",
      "蹋",
      "蹦",
      "蹬",
      "蹭",
      "蹲",
      "躁",
      "身",
      "躬",
      "躯",
      "躲",
      "躺",
      "车",
      "轨",
      "转",
      "轮",
      "软",
      "轰",
      "轴",
      "轻",
      "载",
      "轿",
      "较",
      "辅",
      "辆",
      "辇",
      "辈",
      "辉",
      "辐",
      "辑",
      "输",
      "辕",
      "辖",
      "辗",
      "辙",
      "辛",
      "辜",
      "辞",
      "辟",
      "辡",
      "辣",
      "辨",
      "辩",
      "辫",
      "辰",
      "辱",
      "辶",
      "边",
      "辽",
      "达",
      "迁",
      "迄",
      "迅",
      "过",
      "迈",
      "迎",
      "运",
      "近",
      "返",
      "还",
      "这",
      "进",
      "远",
      "违",
      "连",
      "迟",
      "迪",
      "迫",
      "迭",
      "述",
      "迶",
      "迷",
      "迸",
      "迹",
      "追",
      "退",
      "送",
      "适",
      "逃",
      "逆",
      "选",
      "逊",
      "透",
      "逐",
      "递",
      "途",
      "逗",
      "通",
      "逛",
      "逝",
      "逞",
      "速",
      "造",
      "逢",
      "逮",
      "逸",
      "逻",
      "逼",
      "逾",
      "遀",
      "遂",
      "遇",
      "遍",
      "遏",
      "道",
      "遗",
      "遛",
      "遣",
      "遥",
      "遭",
      "遮",
      "遵",
      "避",
      "邀",
      "邃",
      "邓",
      "那",
      "邦",
      "邪",
      "邮",
      "邻",
      "郁",
      "郊",
      "郎",
      "郑",
      "部",
      "郭",
      "都",
      "鄙",
      "酉",
      "酋",
      "酌",
      "配",
      "酒",
      "酗",
      "酝",
      "酣",
      "酥",
      "酪",
      "酬",
      "酱",
      "酵",
      "酷",
      "酸",
      "酿",
      "醇",
      "醉",
      "醋",
      "醒",
      "醮",
      "釆",
      "采",
      "释",
      "里",
      "重",
      "野",
      "量",
      "金",
      "鉴",
      "钅",
      "针",
      "钉",
      "钓",
      "钙",
      "钝",
      "钞",
      "钟",
      "钢",
      "钥",
      "钦",
      "钧",
      "钩",
      "钮",
      "钱",
      "钳",
      "钻",
      "铁",
      "铃",
      "铅",
      "铜",
      "铝",
      "铭",
      "铲",
      "银",
      "铸",
      "铺",
      "链",
      "销",
      "锁",
      "锄",
      "锅",
      "锈",
      "锋",
      "锐",
      "错",
      "锡",
      "锤",
      "锦",
      "键",
      "锯",
      "锲",
      "锻",
      "镇",
      "镑",
      "镜",
      "镶",
      "镸",
      "长",
      "门",
      "闪",
      "闭",
      "问",
      "闯",
      "闰",
      "闲",
      "间",
      "闷",
      "闸",
      "闹",
      "闺",
      "闻",
      "阀",
      "阁",
      "阂",
      "阅",
      "阎",
      "阐",
      "阑",
      "阔",
      "阝",
      "队",
      "阱",
      "防",
      "阳",
      "阴",
      "阵",
      "阶",
      "阻",
      "阿",
      "附",
      "际",
      "陆",
      "陈",
      "陋",
      "陌",
      "降",
      "陏",
      "限",
      "陡",
      "院",
      "除",
      "陨",
      "险",
      "陪",
      "陵",
      "陶",
      "陷",
      "隆",
      "随",
      "隐",
      "隔",
      "隘",
      "隙",
      "障",
      "隧",
      "隶",
      "隹",
      "隺",
      "隽",
      "难",
      "雀",
      "雁",
      "雄",
      "雅",
      "集",
      "雇",
      "雌",
      "雕",
      "雚",
      "雨",
      "雪",
      "零",
      "雷",
      "雹",
      "雾",
      "需",
      "震",
      "霉",
      "霍",
      "霜",
      "霞",
      "露",
      "霸",
      "靑",
      "青",
      "静",
      "非",
      "靠",
      "面",
      "革",
      "靴",
      "靶",
      "鞋",
      "鞠",
      "鞭",
      "韦",
      "韧",
      "韩",
      "音",
      "韵",
      "頁",
      "页",
      "顶",
      "顷",
      "项",
      "顺",
      "须",
      "顽",
      "顾",
      "顿",
      "颁",
      "颂",
      "预",
      "领",
      "颇",
      "颈",
      "颊",
      "频",
      "颓",
      "颖",
      "颗",
      "题",
      "颜",
      "额",
      "颠",
      "颤",
      "风",
      "飘",
      "飙",
      "飞",
      "食",
      "餐",
      "饣",
      "饥",
      "饪",
      "饭",
      "饮",
      "饰",
      "饱",
      "饲",
      "饵",
      "饶",
      "饺",
      "饼",
      "饿",
      "馁",
      "馅",
      "馆",
      "馈",
      "馋",
      "馒",
      "首",
      "香",
      "馨",
      "馬",
      "駦",
      "马",
      "驭",
      "驮",
      "驯",
      "驰",
      "驱",
      "驳",
      "驶",
      "驻",
      "驾",
      "骂",
      "骄",
      "骇",
      "验",
      "骏",
      "骑",
      "骗",
      "骚",
      "骤",
      "骨",
      "骼",
      "髓",
      "高",
      "髟",
      "髦",
      "鬲",
      "鬼",
      "魁",
      "魂",
      "魄",
      "魅",
      "魏",
      "魔",
      "鱼",
      "鲁",
      "鲜",
      "鲤",
      "鲨",
      "鲸",
      "鳄",
      "鸟",
      "鸡",
      "鸣",
      "鸦",
      "鸭",
      "鸽",
      "鹅",
      "鹏",
      "鹤",
      "鹰",
      "鹿",
      "麟",
      "麦",
      "麻",
      "黄",
      "黍",
      "黎",
      "黏",
      "黑",
      "默",
      "黾",
      "鼎",
      "鼓",
      "鼠",
      "鼻",
      "齐",
      "齿",
      "龄",
      "龙",
      "龟",
      "龰",
      "龱",
      "龴",
      "龶",
      "龷",
      "龹",
      "𠀐",
      "𠂇",
      "𠂉",
      "𠂊",
      "𠂎",
      "𠂑",
      "𠂤",
      "𠃊",
      "𠃌",
      "𠃓",
      "𠃜",
      "𠆧",
      "𠔏",
      "𠕁",
      "𠠵",
      "𠣜",
      "𠤕",
      "𠦝",
      "𠫔",
      "𠫝",
      "𠬝",
      "𠬤",
      "𠬶",
      "𠮛",
      "𠮦",
      "𠮷",
      "𠳋",
      "𡗗",
      "𡗜",
      "𡗞",
      "𡨄",
      "𡭴",
      "𡰪",
      "𡰯",
      "𡱒",
      "𡵂",
      "𢀖",
      "𢆉",
      "𢆶",
      "𢎥",
      "𢎨",
      "𢛳",
      "𢦏",
      "𢦑",
      "𢼄",
      "𢼸",
      "𣂑",
      "𣌢",
      "𣍢",
      "𣎆",
      "𣢟",
      "𣥂",
      "𣦼",
      "𣬉",
      "𣳾",
      "𤯝",
      "𤰔",
      "𤴓",
      "𤽄",
      "𤿺",
      "𥁕",
      "𥃭",
      "𥃲",
      "𥅛",
      "𥝢",
      "𦈢",
      "𦍌",
      "𦐇",
      "𦙲",
      "𦣞",
      "𦣻",
      "𦥔",
      "𧘇",
      "𧰨",
      "𨾴",
      "𫠣"
    ],
    "rare": [
      "㚇",
      "㡯",
      "䖒",
      "䖭",
      "丢",
      "丫",
      "乾",
      "互",
      "仲",
      "俊",
      "倩",
      "兇",
      "兮",
      "冠",
      "刺",
      "剪",
      "劫",
      "勘",
      "升",
      "卝",
      "卤",
      "厸",
      "吁",
      "吅",
      "哀",
      "坎",
      "埶",
      "夊",
      "奭",
      "婪",
      "学",
      "尨",
      "屑",
      "崇",
      "巂",
      "席",
      "序",
      "廛",
      "弄",
      "弇",
      "律",
      "忌",
      "忒",
      "恒",
      "悘",
      "憂",
      "戲",
      "扣",
      "拔",
      "择",
      "拿",
      "捕",
      "摩",
      "敃",
      "效",
      "教",
      "施",
      "昊",
      "晉",
      "朗",
      "梁",
      "梄",
      "楚",
      "殷",
      "派",
      "温",
      "漂",
      "焊",
      "焱",
      "熱",
      "燕",
      "爯",
      "牌",
      "琶",
      "瑟",
      "画",
      "的",
      "盆",
      "盙",
      "移",
      "穀",
      "突",
      "答",
      "管",
      "糜",
      "糞",
      "絭",
      "红",
      "罡",
      "罽",
      "耎",
      "舂",
      "舋",
      "萦",
      "虘",
      "虱",
      "贳",
      "费",
      "贾",
      "进",
      "逮",
      "遠",
      "適",
      "邪",
      "部",
      "酓",
      "钱",
      "開",
      "雋",
      "雔",
      "零",
      "靡",
      "鬳",
      "魁",
      "黃",
      "龠",
      "𠂭",
      "𠚍",
      "𠬢",
      "𡉼",
      "𡕥",
      "𡿪",
      "𢖻",
      "𦰩"
    ],
    "uncommon": [
      "㕡",
      "㞢",
      "㦰",
      "㧜",
      "㨨",
      "㬎",
      "㼌",
      "䏌",
      "丏",
      "丝",
      "严",
      "丽",
      "举",
      "么",
      "乡",
      "亟",
      "仁",
      "仄",
      "仕",
      "仝",
      "伊",
      "休",
      "位",
      "佘",
      "倍",
      "僕",
      "党",
      "兜",
      "內",
      "冀",
      "再",
      "冓",
      "冥",
      "凹",
      "制",
      "动",
      "勒",
      "匛",
      "匪",
      "医",
      "匿",
      "卞",
      "卡",
      "卮",
      "印",
      "厌",
      "厘",
      "厥",
      "叙",
      "叵",
      "号",
      "否",
      "含",
      "吳",
      "呂",
      "咎",
      "商",
      "善",
      "囊",
      "囙",
      "四",
      "围",
      "固",
      "国",
      "圂",
      "均",
      "坒",
      "坚",
      "垔",
      "塞",
      "壯",
      "壳",
      "壹",
      "处",
      "夒",
      "夲",
      "夵",
      "夾",
      "奋",
      "奎",
      "契",
      "奔",
      "好",
      "威",
      "媷",
      "嬴",
      "季",
      "孤",
      "孨",
      "孱",
      "宅",
      "守",
      "宕",
      "宰",
      "宽",
      "密",
      "寇",
      "寻",
      "寽",
      "封",
      "尌",
      "就",
      "尽",
      "尾",
      "局",
      "屏",
      "岑",
      "巤",
      "帖",
      "帚",
      "常",
      "幸",
      "幹",
      "庚",
      "庸",
      "弘",
      "弥",
      "强",
      "归",
      "得",
      "徙",
      "志",
      "忽",
      "恝",
      "恣",
      "恩",
      "恬",
      "患",
      "悤",
      "惟",
      "意",
      "戍",
      "戚",
      "戛",
      "戢",
      "戻",
      "戾",
      "把",
      "攀",
      "敄",
      "敇",
      "敛",
      "敞",
      "数",
      "斌",
      "斑",
      "斛",
      "断",
      "旅",
      "旋",
      "时",
      "昝",
      "昫",
      "昬",
      "昱",
      "晋",
      "晏",
      "朁",
      "服",
      "朮",
      "松",
      "栗",
      "栾",
      "桀",
      "楙",
      "欮",
      "殄",
      "殹",
      "毒",
      "毕",
      "毚",
      "沃",
      "沛",
      "沮",
      "河",
      "泊",
      "泰",
      "流",
      "浪",
      "海",
      "淫",
      "渠",
      "满",
      "潘",
      "灳",
      "灵",
      "焉",
      "熏",
      "燮",
      "爭",
      "爱",
      "爹",
      "牟",
      "犀",
      "犹",
      "狄",
      "狊",
      "猋",
      "猗",
      "猪",
      "献",
      "甤",
      "甾",
      "畟",
      "畧",
      "畾",
      "疐",
      "皂",
      "皅",
      "皋",
      "皛",
      "盈",
      "県",
      "眔",
      "眘",
      "眞",
      "睘",
      "睢",
      "睪",
      "瞢",
      "瞿",
      "矍",
      "秦",
      "稍",
      "窜",
      "竘",
      "笔",
      "筤",
      "筮",
      "粟",
      "粥",
      "粲",
      "系",
      "素",
      "縣",
      "繁",
      "纂",
      "纣",
      "纯",
      "维",
      "缘",
      "网",
      "罔",
      "羌",
      "羞",
      "羲",
      "羴",
      "習",
      "翕",
      "翰",
      "耴",
      "肥",
      "肩",
      "背",
      "脊",
      "脩",
      "臬",
      "臺",
      "臾",
      "舄",
      "艳",
      "艺",
      "节",
      "芒",
      "芬",
      "苜",
      "英",
      "茶",
      "荃",
      "荐",
      "荣",
      "荷",
      "莹",
      "莽",
      "菐",
      "萠",
      "萹",
      "著",
      "葛",
      "蒦",
      "蒿",
      "薄",
      "虏",
      "虐",
      "虒",
      "虖",
      "號",
      "蚩",
      "蜀",
      "行",
      "衍",
      "衡",
      "表",
      "衰",
      "訇",
      "许",
      "豊",
      "豐",
      "豖",
      "豦",
      "豩",
      "貍",
      "质",
      "赞",
      "赣",
      "赦",
      "越",
      "轨",
      "转",
      "边",
      "达",
      "迁",
      "过",
      "追",
      "通",
      "進",
      "遽",
      "邑",
      "邛",
      "都",
      "醮",
      "釜",
      "钦",
      "闲",
      "闷",
      "闾",
      "阞",
      "陟",
      "除",
      "隋",
      "隻",
      "隼",
      "雁",
      "雍",
      "雩",
      "雪",
      "霍",
      "霜",
      "霝",
      "霸",
      "韭",
      "韱",
      "须",
      "预",
      "颉",
      "颢",
      "飤",
      "餐",
      "魚",
      "魝",
      "鲁",
      "鹿",
      "麃",
      "麦",
      "麽",
      "黍",
      "黎",
      "黹",
      "鼎",
      "鼓",
      "鼠",
      "鼻",
      "龟",
      "𠁳",
      "𠂆",
      "𠂋",
      "𠇍",
      "𠖇",
      "𠤏",
      "𠩺",
      "𠫤",
      "𠱠",
      "𡉀",
      "𡘽",
      "𢇁",
      "𣎳",
      "𣪊",
      "𣪠",
      "𣬉",
      "𤍾",
      "𤕻",
      "𥁑",
      "𥁓",
      "𥃺",
      "𥬥",
      "𥸲",
      "𧈧",
      "𨊥"
    ]
  },
  "traditional": {
    "common": [
      "⺁",
      "⺈",
      "⺌",
      "⺕",
      "⺳",
      "⺽",
      "㇇",
      "㇏",
      "㐄",
      "㐆",
      "㐌",
      "㐫",
      "㐬",
      "㐭",
      "㐱",
      "㒸",
      "㒼",
      "㓞",
      "㔾",
      "㕣",
      "㝴",
      "㠯",
      "㡀",
      "㡭",
      "㢆",
      "㣺",
      "㥁",
      "㦰",
      "㫃",
      "㫗",
      "㬎",
      "㳄",
      "㳟",
      "㸒",
      "㸚",
      "㽞",
      "䍃",
      "䏍",
      "䏎",
      "䒑",
      "䖒",
      "䖵",
      "䚯",
      "䜌",
      "䧹",
      "䩗",
      "一",
      "丁",
      "丂",
      "七",
      "丄",
      "丆",
      "丈",
      "三",
      "上",
      "丌",
      "不",
      "丐",
      "丑",
      "且",
      "世",
      "丘",
      "丙",
      "业",
      "丞",
      "並",
      "丨",
      "丩",
      "中",
      "丯",
      "丰",
      "串",
      "丵",
      "丶",
      "丷",
      "丸",
      "主",
      "丽",
      "丿",
      "乁",
      "乂",
      "乃",
      "乄",
      "久",
      "乇",
      "之",
      "乍",
      "乎",
      "乏",
      "乑",
      "乘",
      "乙",
      "乚",
      "乛",
      "乜",
      "九",
      "乞",
      "也",
      "习",
      "乡",
      "亅",
      "了",
      "亇",
      "予",
      "二",
      "于",
      "亏",
      "亐",
      "云",
      "五",
      "井",
      "亘",
      "亙",
      "亚",
      "亞",
      "亠",
      "亡",
      "亢",
      "交",
      "亥",
      "亦",
      "产",
      "亨",
      "享",
      "京",
      "亭",
      "亲",
      "亶",
      "人",
      "亻",
      "亼",
      "亽",
      "亾",
      "今",
      "介",
      "仌",
      "从",
      "仒",
      "付",
      "代",
      "令",
      "任",
      "伏",
      "伐",
      "众",
      "何",
      "余",
      "你",
      "佰",
      "侌",
      "侖",
      "侯",
      "便",
      "保",
      "俞",
      "倉",
      "倍",
      "倠",
      "僉",
      "儿",
      "兀",
      "允",
      "元",
      "兄",
      "充",
      "兆",
      "先",
      "光",
      "兌",
      "免",
      "兒",
      "兔",
      "入",
      "全",
      "兩",
      "兪",
      "八",
      "公",
      "六",
      "共",
      "关",
      "其",
      "具",
      "兹",
      "兼",
      "冂",
      "冃",
      "冄",
      "内",
      "円",
      "冉",
      "冊",
      "冋",
      "再",
      "冎",
      "冏",
      "冐",
      "冒",
      "冓",
      "冖",
      "冗",
      "冘",
      "冡",
      "冫",
      "冬",
      "几",
      "凡",
      "凧",
      "凵",
      "凶",
      "出",
      "函",
      "刀",
      "刂",
      "刃",
      "刅",
      "分",
      "刍",
      "刑",
      "刖",
      "列",
      "利",
      "到",
      "制",
      "刷",
      "則",
      "剌",
      "前",
      "力",
      "加",
      "务",
      "劦",
      "勇",
      "務",
      "勞",
      "勹",
      "勺",
      "勿",
      "匀",
      "匃",
      "包",
      "匈",
      "匊",
      "匋",
      "匍",
      "匐",
      "匕",
      "化",
      "北",
      "匚",
      "匝",
      "匡",
      "匹",
      "医",
      "區",
      "十",
      "卂",
      "千",
      "卉",
      "半",
      "卌",
      "卑",
      "卒",
      "卓",
      "卜",
      "卝",
      "占",
      "卦",
      "卩",
      "卪",
      "卬",
      "卯",
      "危",
      "卷",
      "卸",
      "卻",
      "厂",
      "厃",
      "厄",
      "厓",
      "原",
      "厤",
      "厥",
      "厭",
      "厲",
      "厶",
      "厷",
      "去",
      "厽",
      "叀",
      "參",
      "又",
      "叉",
      "及",
      "友",
      "反",
      "叐",
      "叒",
      "叔",
      "叕",
      "取",
      "受",
      "叚",
      "叟",
      "口",
      "古",
      "句",
      "另",
      "召",
      "可",
      "台",
      "史",
      "右",
      "号",
      "司",
      "吂",
      "各",
      "合",
      "吉",
      "吋",
      "同",
      "名",
      "后",
      "吏",
      "向",
      "吕",
      "君",
      "启",
      "吳",
      "吾",
      "呂",
      "呆",
      "呈",
      "呉",
      "告",
      "呑",
      "周",
      "咅",
      "咠",
      "咨",
      "咸",
      "咼",
      "品",
      "員",
      "哥",
      "唐",
      "啇",
      "啚",
      "喜",
      "喬",
      "單",
      "喿",
      "嘼",
      "囗",
      "囚",
      "回",
      "囟",
      "因",
      "困",
      "囱",
      "囷",
      "固",
      "土",
      "圣",
      "圥",
      "圭",
      "圼",
      "坐",
      "坴",
      "垂",
      "垔",
      "垚",
      "埶",
      "執",
      "基",
      "堇",
      "堯",
      "士",
      "壬",
      "壯",
      "声",
      "壴",
      "壽",
      "夂",
      "夃",
      "处",
      "夅",
      "夆",
      "夊",
      "夋",
      "夌",
      "复",
      "夏",
      "夓",
      "夕",
      "夗",
      "多",
      "夜",
      "大",
      "天",
      "太",
      "夫",
      "夬",
      "夭",
      "央",
      "失",
      "夷",
      "夸",
      "夾",
      "奄",
      "奇",
      "奉",
      "奏",
      "奐",
      "奚",
      "奞",
      "奠",
      "奧",
      "女",
      "奴",
      "如",
      "妟",
      "妥",
      "妻",
      "妾",
      "姑",
      "委",
      "婁",
      "嬰",
      "子",
      "孔",
      "孚",
      "孛",
      "孝",
      "孟",
      "孫",
      "孰",
      "宀",
      "它",
      "安",
      "完",
      "宓",
      "宗",
      "官",
      "定",
      "宛",
      "宜",
      "客",
      "宣",
      "害",
      "家",
      "宷",
      "容",
      "宿",
      "寍",
      "察",
      "寧",
      "審",
      "寫",
      "寸",
      "寺",
      "封",
      "尃",
      "射",
      "將",
      "專",
      "尉",
      "尊",
      "尌",
      "小",
      "少",
      "尔",
      "尗",
      "尚",
      "尞",
      "尢",
      "尤",
      "尸",
      "尹",
      "尼",
      "尿",
      "屈",
      "屋",
      "展",
      "屚",
      "屬",
      "屮",
      "屯",
      "屰",
      "山",
      "岡",
      "島",
      "崔",
      "崩",
      "嵒",
      "巂",
      "巛",
      "巜",
      "川",
      "州",
      "巟",
      "巠",
      "巤",
      "工",
      "左",
      "巨",
      "巩",
      "巫",
      "差",
      "己",
      "巳",
      "巴",
      "巻",
      "巽",
      "巾",
      "巿",
      "帀",
      "市",
      "布",
      "希",
      "帚",
      "帛",
      "帝",
      "師",
      "帶",
      "干",
      "平",
      "并",
      "幸",
      "幺",
      "幾",
      "广",
      "府",
      "度",
      "庫",
      "庶",
      "康",
      "庸",
      "廉",
      "廌",
      "廚",
      "廛",
      "廣",
      "廴",
      "延",
      "廷",
      "建",
      "廾",
      "廿",
      "开",
      "弋",
      "弍",
      "式",
      "弓",
      "弔",
      "弗",
      "弟",
      "弱",
      "張",
      "彌",
      "彎",
      "彐",
      "彑",
      "彔",
      "录",
      "彖",
      "彗",
      "彡",
      "彥",
      "彭",
      "彳",
      "從",
      "御",
      "復",
      "微",
      "徵",
      "心",
      "忄",
      "必",
      "忍",
      "志",
      "忝",
      "快",
      "忽",
      "思",
      "恩",
      "息",
      "悤",
      "惟",
      "愈",
      "意",
      "感",
      "慮",
      "憂",
      "戈",
      "戊",
      "戌",
      "戍",
      "戎",
      "成",
      "我",
      "戒",
      "戔",
      "戕",
      "或",
      "戠",
      "戶",
      "户",
      "戸",
      "戾",
      "扁",
      "手",
      "扌",
      "才",
      "折",
      "拉",
      "拜",
      "支",
      "攵",
      "攸",
      "故",
      "敇",
      "敏",
      "敕",
      "敖",
      "敝",
      "敞",
      "散",
      "敦",
      "敫",
      "敬",
      "文",
      "斗",
      "斤",
      "斥",
      "斬",
      "斯",
      "新",
      "方",
      "於",
      "斿",
      "旁",
      "旡",
      "既",
      "日",
      "旦",
      "旨",
      "早",
      "旬",
      "旱",
      "旲",
      "昆",
      "昌",
      "明",
      "昏",
      "易",
      "昔",
      "昗",
      "昚",
      "昜",
      "星",
      "春",
      "昭",
      "是",
      "普",
      "景",
      "暴",
      "曰",
      "曲",
      "曳",
      "更",
      "曷",
      "曹",
      "曼",
      "曽",
      "曾",
      "朁",
      "會",
      "月",
      "有",
      "朋",
      "朔",
      "朝",
      "木",
      "朩",
      "未",
      "末",
      "本",
      "札",
      "朮",
      "术",
      "朱",
      "朵",
      "朿",
      "束",
      "東",
      "杲",
      "松",
      "析",
      "林",
      "果",
      "枼",
      "某",
      "柔",
      "查",
      "柬",
      "柰",
      "桀",
      "桑",
      "桼",
      "梁",
      "棥",
      "樂",
      "樊",
      "欠",
      "次",
      "欣",
      "欮",
      "欲",
      "欶",
      "止",
      "正",
      "此",
      "步",
      "武",
      "歹",
      "死",
      "殳",
      "段",
      "殸",
      "殹",
      "毋",
      "毌",
      "母",
      "每",
      "比",
      "毛",
      "氏",
      "氐",
      "民",
      "气",
      "水",
      "氵",
      "氶",
      "氺",
      "氾",
      "氿",
      "求",
      "汆",
      "汒",
      "沓",
      "泙",
      "波",
      "洰",
      "活",
      "海",
      "涂",
      "淮",
      "湯",
      "溥",
      "滕",
      "澡",
      "火",
      "灬",
      "灰",
      "灳",
      "炎",
      "炏",
      "炗",
      "炭",
      "為",
      "烏",
      "烕",
      "烝",
      "焄",
      "無",
      "焦",
      "然",
      "爪",
      "爫",
      "爭",
      "爰",
      "爵",
      "父",
      "爻",
      "爾",
      "爿",
      "片",
      "牙",
      "牚",
      "牛",
      "牜",
      "犀",
      "犬",
      "犭",
      "犮",
      "狂",
      "猒",
      "玄",
      "率",
      "玉",
      "王",
      "珀",
      "瓜",
      "瓦",
      "甘",
      "甚",
      "生",
      "産",
      "用",
      "甫",
      "甬",
      "田",
      "由",
      "甲",
      "申",
      "电",
      "男",
      "甹",
      "畀",
      "畏",
      "畐",
      "畕",
      "留",
      "畜",
      "番",
      "畫",
      "異",
      "當",
      "畺",
      "畾",
      "疋",
      "疌",
      "疏",
      "疐",
      "疑",
      "疒",
      "疾",
      "癶",
      "登",
      "發",
      "白",
      "百",
      "皃",
      "皆",
      "皇",
      "皮",
      "皿",
      "益",
      "盍",
      "盡",
      "監",
      "盧",
      "目",
      "直",
      "相",
      "盾",
      "眉",
      "県",
      "眔",
      "真",
      "睘",
      "睪",
      "瞿",
      "矛",
      "矞",
      "矢",
      "矣",
      "知",
      "石",
      "示",
      "礻",
      "祘",
      "票",
      "祭",
      "禁",
      "禸",
      "禺",
      "离",
      "禾",
      "禿",
      "秀",
      "秋",
      "秝",
      "穌",
      "穴",
      "空",
      "立",
      "竞",
      "竟",
      "章",
      "童",
      "竹",
      "筑",
      "米",
      "粦",
      "粲",
      "糸",
      "糹",
      "系",
      "約",
      "索",
      "絜",
      "維",
      "縣",
      "缶",
      "网",
      "罒",
      "罔",
      "罙",
      "署",
      "罷",
      "羅",
      "羊",
      "羌",
      "美",
      "羔",
      "義",
      "羲",
      "羽",
      "翏",
      "習",
      "翟",
      "老",
      "耂",
      "考",
      "者",
      "耆",
      "而",
      "耑",
      "耒",
      "耤",
      "耳",
      "耴",
      "聚",
      "聶",
      "聽",
      "聿",
      "肀",
      "肅",
      "肉",
      "肋",
      "肖",
      "肙",
      "肰",
      "育",
      "肴",
      "胃",
      "胡",
      "胥",
      "能",
      "臣",
      "臤",
      "臧",
      "自",
      "臭",
      "臱",
      "至",
      "致",
      "臼",
      "臽",
      "臿",
      "舀",
      "舂",
      "舄",
      "與",
      "舌",
      "舍",
      "舛",
      "舜",
      "舟",
      "般",
      "艮",
      "良",
      "艹",
      "艾",
      "芇",
      "芻",
      "苗",
      "苜",
      "苟",
      "若",
      "荅",
      "荒",
      "莫",
      "菐",
      "華",
      "萈",
      "萬",
      "萹",
      "董",
      "葬",
      "蒙",
      "蒦",
      "蓺",
      "蔑",
      "蕭",
      "藏",
      "虍",
      "虎",
      "虒",
      "虚",
      "虛",
      "虫",
      "虽",
      "蚤",
      "蜀",
      "血",
      "衣",
      "衤",
      "表",
      "袁",
      "褱",
      "襄",
      "襾",
      "西",
      "覀",
      "要",
      "覃",
      "見",
      "規",
      "親",
      "覺",
      "覽",
      "角",
      "觜",
      "解",
      "言",
      "訧",
      "詹",
      "諸",
      "謁",
      "谷",
      "豆",
      "豈",
      "豊",
      "豐",
      "豕",
      "豙",
      "象",
      "豦",
      "豸",
      "貇",
      "貝",
      "貞",
      "負",
      "貫",
      "責",
      "貳",
      "貴",
      "買",
      "賁",
      "賓",
      "賞",
      "賣",
      "賤",
      "賴",
      "贊",
      "贝",
      "负",
      "赤",
      "赫",
      "走",
      "足",
      "身",
      "躬",
      "車",
      "軍",
      "辛",
      "辟",
      "辡",
      "辰",
      "農",
      "辶",
      "迷",
      "退",
      "造",
      "逢",
      "連",
      "遀",
      "遂",
      "道",
      "遣",
      "那",
      "邦",
      "郎",
      "郭",
      "鄉",
      "鄭",
      "酉",
      "酋",
      "釆",
      "采",
      "里",
      "重",
      "野",
      "量",
      "金",
      "長",
      "镸",
      "門",
      "閏",
      "間",
      "閣",
      "闌",
      "阝",
      "阿",
      "陰",
      "隊",
      "隋",
      "隱",
      "隶",
      "隹",
      "隺",
      "隻",
      "雇",
      "雈",
      "雍",
      "雐",
      "雔",
      "雚",
      "離",
      "難",
      "雨",
      "雷",
      "需",
      "霝",
      "靑",
      "青",
      "非",
      "面",
      "革",
      "韋",
      "韭",
      "韱",
      "音",
      "頁",
      "頃",
      "須",
      "領",
      "頻",
      "風",
      "食",
      "飬",
      "首",
      "香",
      "馬",
      "馮",
      "駦",
      "骨",
      "高",
      "髟",
      "鬥",
      "鬯",
      "鬲",
      "鬳",
      "鬼",
      "魚",
      "鳥",
      "鹵",
      "鹿",
      "麗",
      "麥",
      "麻",
      "黃",
      "黄",
      "黍",
      "黑",
      "黽",
      "鼠",
      "齊",
      "齒",
      "龍",
      "龠",
      "龥",
      "龰",
      "龴",
      "龶",
      "龷",
      "龹",
      "𠀐",
      "𠁳",
      "𠂇",
      "𠂉",
      "𠂎",
      "𠂑",
      "𠂔",
      "𠂤",
      "𠂭",
      "𠃊",
      "𠃌",
      "𠃜",
      "𠓜",
      "𠔏",
      "𠕁",
      "𠙽",
      "𠚍",
      "𠣜",
      "𠤕",
      "𠦒",
      "𠦝",
      "𠩺",
      "𠪚",
      "𠫔",
      "𠫝",
      "𠫯",
      "𠬛",
      "𠬝",
      "𠬶",
      "𠮛",
      "𠮷",
      "𠱠",
      "𠳋",
      "𡉀",
      "𡗗",
      "𡗜",
      "𡗞",
      "𡨄",
      "𡩜",
      "𡭴",
      "𡯄",
      "𡰪",
      "𡰯",
      "𡱒",
      "𡵂",
      "𡿺",
      "𢆉",
      "𢆶",
      "𢆸",
      "𢇁",
      "𢇇",
      "𢎥",
      "𢎨",
      "𢖻",
      "𢛳",
      "𢦏",
      "𢧜",
      "𢼸",
      "𣌢",
      "𣍢",
      "𣎆",
      "𣎳",
      "𣏂",
      "𣥂",
      "𣦼",
      "𣪠",
      "𣳾",
      "𣶒",
      "𤔔",
      "𤯝",
      "𤰔",
      "𤴓",
      "𤽄",
      "𥁕",
      "𥃭",
      "𥅛",
      "𥝢",
      "𦈢",
      "𦍌",
      "𦍎",
      "𦍒",
      "𦐇",
      "𦔻",
      "𦗟",
      "𦣻",
      "𦥔",
      "𦥯",
      "𦰩",
      "𧆨",
      "𧈧",
      "𧘇",
      "𧰨",
      "𧴪",
      "𨊠",
      "𨊥",
      "𨥫",
      "𨾴",
      "𩾏"
    ],
    "graded": [
      "⺁",
      "⺈",
      "⺌",
      "⺕",
      "⺳",
      "⺽",
      "㇇",
      "㇏",
      "㐄",
      "㐆",
      "㐌",
      "㐫",
      "㐬",
      "㐭",
      "㐱",
      "㒸",
      "㒼",
      "㓞",
      "㔾",
      "㕣",
      "㝴",
      "㠯",
      "㡀",
      "㡭",
      "㢆",
      "㣺",
      "㥁",
      "㦰",
      "㫃",
      "㫗",
      "㬎",
      "㳄",
      "㳟",
      "㸒",
      "㸚",
      "㽞",
      "䍃",
      "䏍",
      "䏎",
      "䒑",
      "䖒",
      "䖵",
      "䚯",
      "䜌",
      "䧹",
      "䩗",
      "一",
      "丁",
      "丂",
      "七",
      "丄",
      "丆",
      "丈",
      "三",
      "上",
      "下",
      "丌",
      "不",
      "丐",
      "丑",
      "且",
      "世",
      "丘",
      "丙",
      "业",
      "丞",
      "丟",
      "並",
      "丨",
      "丩",
      "中",
      "丯",
      "丰",
      "串",
      "丵",
      "丶",
      "丷",
      "丸",
      "丹",
      "主",
      "丽",
      "丿",
      "乁",
      "乂",
      "乃",
      "乄",
      "久",
      "乇",
      "之",
      "乍",
      "乎",
      "乏",
      "乑",
      "乒",
      "乓",
      "乖",
      "乘",
      "乙",
      "乚",
      "乛",
      "乜",
      "九",
      "乞",
      "也",
      "习",
      "乡",
      "乳",
      "乾",
      "亂",
      "亅",
      "了",
      "亇",
      "予",
      "二",
      "于",
      "亏",
      "亐",
      "云",
      "五",
      "井",
      "亘",
      "亙",
      "亚",
      "亞",
      "亠",
      "亡",
      "亢",
      "交",
      "亥",
      "亦",
      "产",
      "亨",
      "享",
      "京",
      "亭",
      "亮",
      "亲",
      "亶",
      "人",
      "亻",
      "亼",
      "亽",
      "亾",
      "什",
      "仇",
      "今",
      "介",
      "仌",
      "仍",
      "从",
      "仒",
      "仔",
      "他",
      "付",
      "仙",
      "代",
      "令",
      "以",
      "仰",
      "仲",
      "任",
      "份",
      "仿",
      "企",
      "伍",
      "伏",
      "伐",
      "众",
      "伙",
      "估",
      "伴",
      "伶",
      "伺",
      "但",
      "佈",
      "位",
      "低",
      "佐",
      "佑",
      "佔",
      "何",
      "余",
      "佛",
      "作",
      "你",
      "佩",
      "佰",
      "併",
      "使",
      "來",
      "侈",
      "例",
      "侌",
      "侍",
      "侖",
      "供",
      "依",
      "侮",
      "侯",
      "侵",
      "侶",
      "侷",
      "便",
      "係",
      "促",
      "俄",
      "俊",
      "俐",
      "俘",
      "保",
      "俞",
      "俠",
      "信",
      "修",
      "俯",
      "俱",
      "倆",
      "倉",
      "個",
      "倍",
      "們",
      "倒",
      "倖",
      "候",
      "倚",
      "借",
      "倠",
      "倡",
      "倦",
      "倫",
      "值",
      "假",
      "偉",
      "做",
      "健",
      "側",
      "偵",
      "偶",
      "偽",
      "傀",
      "傅",
      "傍",
      "傑",
      "傘",
      "備",
      "傢",
      "催",
      "傭",
      "傲",
      "傳",
      "債",
      "傻",
      "傾",
      "僅",
      "僉",
      "像",
      "僑",
      "僕",
      "僥",
      "僱",
      "僵",
      "僻",
      "儀",
      "億",
      "儉",
      "儒",
      "儘",
      "償",
      "儡",
      "優",
      "儲",
      "儿",
      "兀",
      "允",
      "元",
      "兄",
      "充",
      "兆",
      "兇",
      "先",
      "光",
      "克",
      "兌",
      "免",
      "兒",
      "兔",
      "兜",
      "入",
      "全",
      "兩",
      "兪",
      "八",
      "公",
      "六",
      "兮",
      "共",
      "关",
      "其",
      "具",
      "典",
      "兹",
      "兼",
      "冂",
      "冃",
      "冄",
      "内",
      "円",
      "冉",
      "冊",
      "冋",
      "再",
      "冎",
      "冏",
      "冐",
      "冒",
      "冓",
      "冖",
      "冗",
      "冘",
      "冠",
      "冡",
      "冤",
      "冥",
      "冫",
      "冬",
      "冰",
      "冷",
      "准",
      "凋",
      "凌",
      "凍",
      "凝",
      "几",
      "凡",
      "凧",
      "凰",
      "凱",
      "凳",
      "凵",
      "凶",
      "凸",
      "凹",
      "出",
      "函",
      "刀",
      "刂",
      "刃",
      "刅",
      "分",
      "刊",
      "刍",
      "刑",
      "划",
      "刖",
      "列",
      "判",
      "刨",
      "利",
      "刪",
      "刮",
      "到",
      "制",
      "刷",
      "券",
      "刻",
      "則",
      "削",
      "剌",
      "前",
      "剎",
      "剔",
      "剖",
      "剛",
      "剝",
      "剩",
      "剪",
      "副",
      "割",
      "創",
      "劃",
      "劈",
      "劉",
      "劍",
      "劑",
      "力",
      "功",
      "加",
      "务",
      "劣",
      "劦",
      "助",
      "努",
      "劫",
      "勁",
      "勃",
      "勇",
      "勉",
      "勒",
      "動",
      "勘",
      "務",
      "勞",
      "募",
      "勤",
      "勵",
      "勹",
      "勺",
      "勻",
      "勾",
      "勿",
      "匀",
      "匃",
      "包",
      "匆",
      "匈",
      "匊",
      "匋",
      "匍",
      "匐",
      "匕",
      "化",
      "北",
      "匙",
      "匚",
      "匝",
      "匠",
      "匡",
      "匪",
      "匯",
      "匹",
      "医",
      "匿",
      "區",
      "十",
      "卂",
      "千",
      "午",
      "卉",
      "半",
      "卌",
      "卑",
      "卒",
      "卓",
      "協",
      "南",
      "博",
      "卜",
      "卝",
      "占",
      "卦",
      "卩",
      "卪",
      "卬",
      "卯",
      "印",
      "危",
      "卵",
      "卷",
      "卸",
      "卻",
      "厂",
      "厃",
      "厄",
      "厓",
      "厚",
      "原",
      "厤",
      "厥",
      "厭",
      "厲",
      "厶",
      "厷",
      "去",
      "厽",
      "叀",
      "參",
      "又",
      "叉",
      "及",
      "友",
      "反",
      "叐",
      "叒",
      "叔",
      "叕",
      "取",
      "受",
      "叚",
      "叛",
      "叟",
      "叢",
      "口",
      "古",
      "句",
      "另",
      "叨",
      "叩",
      "叫",
      "召",
      "叭",
      "叮",
      "可",
      "台",
      "史",
      "右",
      "号",
      "司",
      "吂",
      "吃",
      "各",
      "合",
      "吉",
      "吊",
      "吋",
      "同",
      "名",
      "后",
      "吏",
      "向",
      "吕",
      "君",
      "吝",
      "吟",
      "吧",
      "吩",
      "含",
      "启",
      "吳",
      "吻",
      "吼",
      "吾",
      "呀",
      "呂",
      "呆",
      "呈",
      "呉",
      "告",
      "呑",
      "呢",
      "周",
      "味",
      "呵",
      "呻",
      "呼",
      "咀",
      "咅",
      "和",
      "咎",
      "咐",
      "咒",
      "咕",
      "咖",
      "咠",
      "咦",
      "咨",
      "咪",
      "咬",
      "咱",
      "咳",
      "咸",
      "咼",
      "咽",
      "哀",
      "品",
      "哄",
      "哇",
      "哎",
      "員",
      "哥",
      "哦",
      "哩",
      "哪",
      "哭",
      "哲",
      "哺",
      "哼",
      "唆",
      "唐",
      "售",
      "唯",
      "唱",
      "唾",
      "啄",
      "商",
      "啇",
      "啊",
      "問",
      "啚",
      "啞",
      "啟",
      "啡",
      "啤",
      "啦",
      "啼",
      "善",
      "喇",
      "喉",
      "喊",
      "喘",
      "喚",
      "喜",
      "喝",
      "喧",
      "喪",
      "喬",
      "單",
      "喲",
      "喻",
      "喿",
      "嗅",
      "嗆",
      "嗇",
      "嗎",
      "嗓",
      "嗚",
      "嗜",
      "嗦",
      "嗨",
      "嗯",
      "嗽",
      "嘉",
      "嘍",
      "嘔",
      "嘛",
      "嘩",
      "嘮",
      "嘯",
      "嘲",
      "嘴",
      "嘻",
      "嘼",
      "嘿",
      "噁",
      "噓",
      "噢",
      "噪",
      "噴",
      "嚀",
      "嚇",
      "嚏",
      "嚨",
      "嚮",
      "嚴",
      "嚷",
      "嚼",
      "囉",
      "囊",
      "囑",
      "囗",
      "囚",
      "四",
      "回",
      "囟",
      "因",
      "困",
      "囱",
      "囷",
      "固",
      "圈",
      "國",
      "圍",
      "園",
      "圖",
      "團",
      "土",
      "圣",
      "圥",
      "圭",
      "圼",
      "圾",
      "均",
      "坊",
      "坎",
      "坐",
      "坑",
      "坡",
      "坤",
      "坦",
      "坪",
      "坴",
      "坷",
      "垂",
      "垃",
      "垔",
      "垚",
      "垢",
      "埃",
      "埋",
      "城",
      "埔",
      "域",
      "埶",
      "執",
      "培",
      "基",
      "堂",
      "堆",
      "堇",
      "堡",
      "堤",
      "堪",
      "堯",
      "報",
      "場",
      "堵",
      "塌",
      "塑",
      "塔",
      "塗",
      "塘",
      "塞",
      "塵",
      "墅",
      "墊",
      "墓",
      "墜",
      "增",
      "墟",
      "墨",
      "墮",
      "墳",
      "墾",
      "壁",
      "壇",
      "壓",
      "壘",
      "壞",
      "壟",
      "壤",
      "士",
      "壬",
      "壯",
      "声",
      "壴",
      "壽",
      "夂",
      "夃",
      "处",
      "夅",
      "夆",
      "夊",
      "夋",
      "夌",
      "复",
      "夏",
      "夓",
      "夕",
      "外",
      "夗",
      "多",
      "夜",
      "夢",
      "夥",
      "大",
      "天",
      "太",
      "夫",
      "夬",
      "夭",
      "央",
      "失",
      "夷",
      "夸",
      "夾",
      "奄",
      "奇",
      "奈",
      "奉",
      "奏",
      "奐",
      "契",
      "奔",
      "奕",
      "套",
      "奚",
      "奞",
      "奠",
      "奢",
      "奧",
      "奪",
      "奮",
      "女",
      "奴",
      "奸",
      "她",
      "好",
      "如",
      "妄",
      "妒",
      "妓",
      "妖",
      "妙",
      "妝",
      "妟",
      "妥",
      "妨",
      "妮",
      "妳",
      "妹",
      "妻",
      "妾",
      "姆",
      "姊",
      "始",
      "姐",
      "姑",
      "姓",
      "委",
      "姦",
      "姨",
      "姪",
      "姻",
      "姿",
      "威",
      "娘",
      "娛",
      "娟",
      "婁",
      "婉",
      "婚",
      "婦",
      "婷",
      "婿",
      "媒",
      "媚",
      "媳",
      "媽",
      "嫂",
      "嫉",
      "嫌",
      "嫩",
      "嬉",
      "嬌",
      "嬰",
      "嬸",
      "子",
      "孔",
      "孕",
      "字",
      "孚",
      "孛",
      "孝",
      "孟",
      "季",
      "孤",
      "孩",
      "孫",
      "孰",
      "學",
      "宀",
      "它",
      "宅",
      "宇",
      "安",
      "宋",
      "完",
      "宏",
      "宓",
      "宗",
      "官",
      "宙",
      "定",
      "宛",
      "宜",
      "客",
      "宣",
      "宰",
      "害",
      "宴",
      "家",
      "宷",
      "容",
      "宿",
      "寂",
      "寄",
      "密",
      "富",
      "寍",
      "寒",
      "寞",
      "察",
      "寡",
      "寢",
      "寧",
      "寨",
      "審",
      "寫",
      "寬",
      "寵",
      "寸",
      "寺",
      "封",
      "尃",
      "射",
      "將",
      "專",
      "尉",
      "尊",
      "尋",
      "尌",
      "對",
      "導",
      "小",
      "少",
      "尔",
      "尗",
      "尚",
      "尞",
      "尢",
      "尤",
      "尬",
      "尷",
      "尸",
      "尹",
      "尺",
      "尼",
      "尿",
      "屁",
      "居",
      "屆",
      "屈",
      "屋",
      "屍",
      "屎",
      "屏",
      "屑",
      "展",
      "屚",
      "屜",
      "屠",
      "屢",
      "層",
      "履",
      "屬",
      "屮",
      "屯",
      "屰",
      "山",
      "岔",
      "岡",
      "岩",
      "峭",
      "峰",
      "島",
      "峽",
      "崇",
      "崔",
      "崖",
      "崗",
      "崩",
      "嵒",
      "嶄",
      "嶺",
      "嶼",
      "巂",
      "巛",
      "巜",
      "川",
      "州",
      "巟",
      "巠",
      "巡",
      "巢",
      "巤",
      "工",
      "左",
      "巧",
      "巨",
      "巩",
      "巫",
      "差",
      "己",
      "已",
      "巳",
      "巴",
      "巷",
      "巻",
      "巽",
      "巾",
      "巿",
      "帀",
      "市",
      "布",
      "帆",
      "希",
      "帕",
      "帖",
      "帚",
      "帛",
      "帝",
      "帥",
      "師",
      "席",
      "帳",
      "帶",
      "帽",
      "幅",
      "幕",
      "幟",
      "幣",
      "幫",
      "干",
      "平",
      "年",
      "并",
      "幸",
      "幺",
      "幻",
      "幼",
      "幽",
      "幾",
      "广",
      "庇",
      "床",
      "序",
      "底",
      "府",
      "度",
      "庫",
      "庭",
      "庶",
      "康",
      "庸",
      "廁",
      "廂",
      "廈",
      "廉",
      "廊",
      "廌",
      "廓",
      "廚",
      "廛",
      "廠",
      "廢",
      "廣",
      "廳",
      "廴",
      "延",
      "廷",
      "建",
      "廾",
      "廿",
      "开",
      "弄",
      "弊",
      "弋",
      "弍",
      "式",
      "弓",
      "弔",
      "引",
      "弗",
      "弘",
      "弛",
      "弟",
      "弦",
      "弧",
      "弱",
      "張",
      "強",
      "彈",
      "彌",
      "彎",
      "彐",
      "彑",
      "彔",
      "录",
      "彖",
      "彗",
      "彙",
      "彡",
      "彥",
      "彬",
      "彭",
      "彰",
      "影",
      "彳",
      "彷",
      "役",
      "彼",
      "彿",
      "往",
      "征",
      "很",
      "徊",
      "律",
      "後",
      "徐",
      "徑",
      "徒",
      "徘",
      "從",
      "御",
      "徨",
      "復",
      "循",
      "徬",
      "微",
      "徵",
      "德",
      "徹",
      "心",
      "忄",
      "必",
      "忌",
      "忍",
      "志",
      "忘",
      "忙",
      "忝",
      "忠",
      "快",
      "忽",
      "忿",
      "怎",
      "怒",
      "怕",
      "怖",
      "思",
      "怠",
      "怡",
      "急",
      "怨",
      "怪",
      "怯",
      "恆",
      "恍",
      "恕",
      "恢",
      "恤",
      "恥",
      "恨",
      "恩",
      "恭",
      "息",
      "恰",
      "恿",
      "悄",
      "悅",
      "悉",
      "悔",
      "悟",
      "悠",
      "患",
      "悤",
      "您",
      "悴",
      "悶",
      "悼",
      "情",
      "惋",
      "惑",
      "惕",
      "惚",
      "惜",
      "惟",
      "惠",
      "惰",
      "惱",
      "想",
      "惶",
      "惹",
      "愁",
      "愈",
      "愉",
      "意",
      "愚",
      "愛",
      "感",
      "愧",
      "慈",
      "態",
      "慌",
      "慎",
      "慕",
      "慘",
      "慚",
      "慢",
      "慣",
      "慧",
      "慨",
      "慫",
      "慮",
      "慰",
      "慶",
      "慷",
      "慾",
      "憂",
      "憐",
      "憑",
      "憔",
      "憤",
      "憧",
      "憩",
      "憬",
      "憲",
      "憶",
      "憾",
      "懂",
      "懇",
      "懈",
      "應",
      "懊",
      "懦",
      "懲",
      "懶",
      "懷",
      "懸",
      "懼",
      "戀",
      "戈",
      "戊",
      "戌",
      "戍",
      "戎",
      "成",
      "我",
      "戒",
      "戔",
      "戕",
      "或",
      "戚",
      "戠",
      "截",
      "戰",
      "戲",
      "戴",
      "戶",
      "户",
      "戸",
      "戾",
      "扁",
      "扇",
      "手",
      "扌",
      "才",
      "扎",
      "扒",
      "打",
      "托",
      "扛",
      "扣",
      "扭",
      "扯",
      "扶",
      "批",
      "找",
      "承",
      "技",
      "抄",
      "抉",
      "把",
      "抑",
      "抒",
      "抓",
      "投",
      "抖",
      "抗",
      "折",
      "披",
      "抱",
      "抵",
      "抹",
      "押",
      "抽",
      "拆",
      "拉",
      "拋",
      "拐",
      "拒",
      "拓",
      "拖",
      "拘",
      "拙",
      "招",
      "拜",
      "括",
      "拭",
      "拯",
      "拱",
      "拳",
      "拼",
      "拾",
      "拿",
      "持",
      "指",
      "按",
      "挑",
      "挨",
      "挪",
      "挫",
      "振",
      "挺",
      "挽",
      "挾",
      "捆",
      "捏",
      "捐",
      "捕",
      "捧",
      "捨",
      "捲",
      "捷",
      "掀",
      "掃",
      "授",
      "掉",
      "掌",
      "掏",
      "排",
      "掘",
      "掙",
      "掛",
      "掠",
      "探",
      "接",
      "控",
      "推",
      "掩",
      "措",
      "揀",
      "揉",
      "描",
      "提",
      "插",
      "揚",
      "握",
      "揣",
      "揭",
      "揮",
      "援",
      "損",
      "搏",
      "搓",
      "搗",
      "搜",
      "搞",
      "搭",
      "搶",
      "摔",
      "摘",
      "摟",
      "摧",
      "摩",
      "摯",
      "摸",
      "摺",
      "撇",
      "撈",
      "撐",
      "撒",
      "撓",
      "撕",
      "撤",
      "撥",
      "撩",
      "撫",
      "播",
      "撰",
      "撲",
      "撼",
      "撿",
      "擁",
      "擂",
      "擅",
      "擇",
      "擊",
      "擋",
      "操",
      "擎",
      "擔",
      "據",
      "擠",
      "擦",
      "擬",
      "擱",
      "擲",
      "擴",
      "擺",
      "擾",
      "攀",
      "攏",
      "攔",
      "攜",
      "攝",
      "攤",
      "攪",
      "攬",
      "支",
      "攵",
      "攸",
      "攻",
      "放",
      "政",
      "故",
      "敇",
      "效",
      "敏",
      "敕",
      "敖",
      "敗",
      "敘",
      "敝",
      "敞",
      "敢",
      "散",
      "敦",
      "敫",
      "敬",
      "敷",
      "斃",
      "文",
      "斑",
      "斗",
      "料",
      "斜",
      "斟",
      "斤",
      "斥",
      "斧",
      "斬",
      "斯",
      "新",
      "斷",
      "方",
      "於",
      "施",
      "斿",
      "旁",
      "旅",
      "旋",
      "族",
      "旗",
      "旡",
      "既",
      "日",
      "旦",
      "旨",
      "早",
      "旬",
      "旱",
      "旲",
      "旺",
      "昂",
      "昆",
      "昌",
      "明",
      "昏",
      "易",
      "昔",
      "昗",
      "昚",
      "昜",
      "星",
      "映",
      "春",
      "昧",
      "昨",
      "昭",
      "是",
      "時",
      "晃",
      "晒",
      "晚",
      "晝",
      "普",
      "景",
      "晰",
      "暇",
      "暈",
      "暑",
      "暖",
      "暢",
      "暫",
      "暮",
      "暴",
      "曆",
      "曉",
      "曝",
      "曠",
      "曰",
      "曲",
      "曳",
      "更",
      "曷",
      "書",
      "曹",
      "曼",
      "曽",
      "曾",
      "替",
      "朁",
      "會",
      "月",
      "有",
      "朋",
      "朔",
      "朗",
      "望",
      "朝",
      "期",
      "朦",
      "朧",
      "木",
      "朩",
      "未",
      "末",
      "本",
      "札",
      "朮",
      "术",
      "朱",
      "朵",
      "朽",
      "朿",
      "杏",
      "材",
      "杖",
      "杜",
      "束",
      "東",
      "杲",
      "松",
      "板",
      "枉",
      "析",
      "枕",
      "林",
      "枚",
      "果",
      "枯",
      "枼",
      "柄",
      "柏",
      "某",
      "染",
      "柔",
      "柚",
      "查",
      "柬",
      "柰",
      "柱",
      "柳",
      "柴",
      "柵",
      "栗",
      "校",
      "株",
      "核",
      "格",
      "栽",
      "桀",
      "框",
      "案",
      "桌",
      "桑",
      "桶",
      "桼",
      "桿",
      "梁",
      "梅",
      "條",
      "梨",
      "梭",
      "梯",
      "械",
      "梳",
      "棄",
      "棉",
      "棍",
      "棕",
      "棗",
      "棘",
      "棚",
      "棟",
      "棥",
      "森",
      "棲",
      "棵",
      "棺",
      "椅",
      "椒",
      "楊",
      "楓",
      "楚",
      "楣",
      "業",
      "楷",
      "概",
      "榜",
      "榮",
      "榷",
      "構",
      "槍",
      "槳",
      "槽",
      "樁",
      "樂",
      "樊",
      "樑",
      "樓",
      "標",
      "樸",
      "樹",
      "橋",
      "橘",
      "橙",
      "機",
      "橡",
      "橫",
      "檔",
      "檢",
      "檬",
      "檸",
      "櫥",
      "櫻",
      "欄",
      "權",
      "欠",
      "次",
      "欣",
      "欮",
      "欲",
      "欶",
      "欸",
      "欺",
      "歇",
      "歉",
      "歌",
      "歎",
      "歐",
      "歡",
      "止",
      "正",
      "此",
      "步",
      "武",
      "歧",
      "歪",
      "歲",
      "歷",
      "歸",
      "歹",
      "死",
      "殃",
      "殊",
      "殖",
      "殘",
      "殳",
      "段",
      "殷",
      "殸",
      "殹",
      "殼",
      "殿",
      "毀",
      "毅",
      "毆",
      "毋",
      "毌",
      "母",
      "每",
      "毒",
      "比",
      "毛",
      "毫",
      "毯",
      "氏",
      "氐",
      "民",
      "氓",
      "气",
      "氛",
      "氧",
      "水",
      "氵",
      "氶",
      "永",
      "氺",
      "氾",
      "氿",
      "汁",
      "求",
      "汆",
      "汒",
      "汗",
      "池",
      "污",
      "汪",
      "汰",
      "汲",
      "決",
      "汽",
      "沃",
      "沈",
      "沉",
      "沐",
      "沒",
      "沓",
      "沙",
      "沛",
      "沫",
      "沮",
      "沸",
      "油",
      "治",
      "沼",
      "沾",
      "沿",
      "況",
      "泉",
      "泊",
      "法",
      "泙",
      "泛",
      "泡",
      "波",
      "泣",
      "泥",
      "注",
      "泰",
      "洋",
      "洗",
      "洛",
      "洞",
      "津",
      "洩",
      "洪",
      "洰",
      "洲",
      "洶",
      "活",
      "洽",
      "流",
      "浩",
      "浪",
      "浮",
      "浴",
      "海",
      "浸",
      "涂",
      "消",
      "涉",
      "涕",
      "涮",
      "涯",
      "液",
      "涵",
      "涼",
      "淆",
      "淇",
      "淋",
      "淑",
      "淒",
      "淘",
      "淚",
      "淡",
      "淤",
      "淨",
      "淪",
      "淫",
      "淮",
      "淵",
      "混",
      "淹",
      "添",
      "清",
      "減",
      "渠",
      "渡",
      "渣",
      "測",
      "渲",
      "渴",
      "渾",
      "湃",
      "湊",
      "湧",
      "湯",
      "溉",
      "源",
      "準",
      "溜",
      "溝",
      "溢",
      "溥",
      "溪",
      "溫",
      "溯",
      "溶",
      "溺",
      "滅",
      "滋",
      "滑",
      "滔",
      "滕",
      "滯",
      "滲",
      "滴",
      "滷",
      "漂",
      "漆",
      "漏",
      "漓",
      "漠",
      "漢",
      "漫",
      "漲",
      "漸",
      "漿",
      "潑",
      "潔",
      "潛",
      "潤",
      "潦",
      "潭",
      "潮",
      "潰",
      "澄",
      "澆",
      "澈",
      "澎",
      "澡",
      "澤",
      "澳",
      "激",
      "濁",
      "濃",
      "濕",
      "濛",
      "濟",
      "濤",
      "濫",
      "濱",
      "濺",
      "濾",
      "瀉",
      "瀑",
      "瀕",
      "瀟",
      "瀰",
      "灌",
      "灑",
      "灘",
      "灣",
      "火",
      "灬",
      "灰",
      "灳",
      "灸",
      "灼",
      "災",
      "炎",
      "炏",
      "炒",
      "炗",
      "炫",
      "炭",
      "炮",
      "炸",
      "為",
      "烈",
      "烊",
      "烏",
      "烕",
      "烘",
      "烝",
      "烤",
      "烹",
      "烽",
      "焄",
      "焚",
      "無",
      "焦",
      "焰",
      "然",
      "煌",
      "煞",
      "煤",
      "煥",
      "照",
      "煮",
      "熄",
      "熟",
      "熬",
      "熱",
      "燃",
      "燉",
      "燕",
      "燙",
      "營",
      "燥",
      "燦",
      "燭",
      "燴",
      "爆",
      "爍",
      "爐",
      "爛",
      "爪",
      "爫",
      "爬",
      "爭",
      "爰",
      "爵",
      "父",
      "爸",
      "爻",
      "爽",
      "爾",
      "爿",
      "片",
      "版",
      "牌",
      "牙",
      "牚",
      "牛",
      "牜",
      "牠",
      "牢",
      "牧",
      "牲",
      "特",
      "牽",
      "犀",
      "犧",
      "犬",
      "犭",
      "犮",
      "狂",
      "狐",
      "狗",
      "狠",
      "狡",
      "狸",
      "狹",
      "狽",
      "猒",
      "猖",
      "猛",
      "猴",
      "猶",
      "猾",
      "猿",
      "獄",
      "獎",
      "獗",
      "獨",
      "獲",
      "獵",
      "獸",
      "獻",
      "玄",
      "率",
      "玉",
      "王",
      "玫",
      "玲",
      "玻",
      "珀",
      "珊",
      "班",
      "現",
      "球",
      "琢",
      "琴",
      "瑕",
      "瑞",
      "瑣",
      "瑩",
      "瑰",
      "璃",
      "璧",
      "環",
      "瓜",
      "瓣",
      "瓦",
      "瓶",
      "瓷",
      "甄",
      "甘",
      "甚",
      "甜",
      "生",
      "產",
      "産",
      "甥",
      "甦",
      "用",
      "甩",
      "甫",
      "甬",
      "田",
      "由",
      "甲",
      "申",
      "电",
      "男",
      "甹",
      "畀",
      "界",
      "畏",
      "畐",
      "畔",
      "畕",
      "留",
      "畜",
      "畢",
      "略",
      "番",
      "畫",
      "異",
      "當",
      "畸",
      "畺",
      "畾",
      "疆",
      "疊",
      "疋",
      "疌",
      "疏",
      "疐",
      "疑",
      "疒",
      "疙",
      "疚",
      "疤",
      "疫",
      "疲",
      "疵",
      "疹",
      "疼",
      "疾",
      "病",
      "症",
      "痊",
      "痔",
      "痕",
      "痘",
      "痠",
      "痣",
      "痰",
      "痴",
      "瘓",
      "瘟",
      "瘡",
      "瘤",
      "瘦",
      "瘩",
      "療",
      "癌",
      "癒",
      "癖",
      "癢",
      "癥",
      "癮",
      "癱",
      "癶",
      "登",
      "發",
      "白",
      "百",
      "皂",
      "皃",
      "的",
      "皆",
      "皇",
      "皮",
      "皺",
      "皿",
      "盆",
      "盈",
      "益",
      "盍",
      "盒",
      "盜",
      "盞",
      "盟",
      "盡",
      "監",
      "盤",
      "盧",
      "盪",
      "目",
      "盯",
      "盲",
      "直",
      "相",
      "盼",
      "盾",
      "省",
      "眉",
      "看",
      "県",
      "眔",
      "真",
      "眠",
      "眨",
      "眷",
      "眺",
      "眼",
      "眾",
      "睏",
      "睘",
      "睛",
      "睜",
      "睡",
      "督",
      "睦",
      "睪",
      "睫",
      "睹",
      "瞄",
      "瞇",
      "瞌",
      "瞎",
      "瞞",
      "瞧",
      "瞪",
      "瞬",
      "瞭",
      "瞿",
      "矇",
      "矗",
      "矚",
      "矛",
      "矞",
      "矢",
      "矣",
      "知",
      "矩",
      "矮",
      "矯",
      "石",
      "砂",
      "研",
      "砥",
      "砲",
      "破",
      "砸",
      "硬",
      "硯",
      "碌",
      "碎",
      "碑",
      "碗",
      "碟",
      "碧",
      "碩",
      "碰",
      "碳",
      "確",
      "碼",
      "磁",
      "磅",
      "磚",
      "磨",
      "礁",
      "礙",
      "礦",
      "礪",
      "示",
      "礻",
      "祀",
      "祈",
      "祕",
      "祖",
      "祘",
      "祝",
      "祟",
      "票",
      "祭",
      "祿",
      "禁",
      "禍",
      "禦",
      "禪",
      "禮",
      "禱",
      "禸",
      "禺",
      "离",
      "禽",
      "禾",
      "禿",
      "秀",
      "秉",
      "秋",
      "科",
      "秒",
      "秘",
      "秝",
      "秤",
      "秦",
      "秩",
      "移",
      "稀",
      "稅",
      "程",
      "稍",
      "稚",
      "稠",
      "種",
      "稻",
      "稿",
      "穀",
      "穌",
      "積",
      "穎",
      "穩",
      "穫",
      "穴",
      "究",
      "空",
      "穿",
      "突",
      "窄",
      "窒",
      "窗",
      "窘",
      "窟",
      "窩",
      "窮",
      "窺",
      "竄",
      "竅",
      "竊",
      "立",
      "站",
      "竞",
      "竟",
      "章",
      "童",
      "竭",
      "競",
      "竹",
      "竿",
      "笑",
      "笛",
      "符",
      "笨",
      "第",
      "筆",
      "等",
      "筋",
      "筍",
      "筑",
      "筒",
      "答",
      "策",
      "筷",
      "箏",
      "箭",
      "箱",
      "範",
      "篆",
      "篇",
      "築",
      "篩",
      "篷",
      "簡",
      "簷",
      "簽",
      "簾",
      "簿",
      "籌",
      "籍",
      "籠",
      "籤",
      "籬",
      "籲",
      "米",
      "粒",
      "粗",
      "粥",
      "粦",
      "粲",
      "粵",
      "粹",
      "粽",
      "精",
      "糊",
      "糕",
      "糗",
      "糙",
      "糞",
      "糟",
      "糧",
      "糯",
      "糸",
      "糹",
      "系",
      "糾",
      "紀",
      "約",
      "紊",
      "紋",
      "納",
      "紐",
      "紓",
      "純",
      "紗",
      "紙",
      "級",
      "紛",
      "素",
      "紡",
      "索",
      "紮",
      "累",
      "細",
      "紳",
      "紹",
      "絆",
      "絕",
      "絜",
      "絞",
      "絡",
      "給",
      "絮",
      "統",
      "綁",
      "經",
      "綜",
      "綠",
      "維",
      "綱",
      "網",
      "綴",
      "綵",
      "綻",
      "綽",
      "綿",
      "緊",
      "緒",
      "緝",
      "締",
      "緣",
      "編",
      "緩",
      "練",
      "緻",
      "縛",
      "縣",
      "縫",
      "縮",
      "縱",
      "總",
      "績",
      "繁",
      "繃",
      "繞",
      "繡",
      "繩",
      "繪",
      "繫",
      "繭",
      "繳",
      "繼",
      "繽",
      "續",
      "纏",
      "纖",
      "纜",
      "缶",
      "缸",
      "罐",
      "网",
      "罒",
      "罔",
      "罕",
      "罙",
      "罩",
      "置",
      "罰",
      "署",
      "罵",
      "罷",
      "罹",
      "羅",
      "羊",
      "羌",
      "美",
      "羔",
      "羞",
      "群",
      "羨",
      "義",
      "羲",
      "羹",
      "羽",
      "翁",
      "翅",
      "翏",
      "習",
      "翔",
      "翟",
      "翠",
      "翩",
      "翹",
      "翻",
      "翼",
      "耀",
      "老",
      "耂",
      "考",
      "者",
      "耆",
      "而",
      "耍",
      "耑",
      "耒",
      "耕",
      "耗",
      "耘",
      "耤",
      "耳",
      "耴",
      "耶",
      "耽",
      "聆",
      "聊",
      "聖",
      "聘",
      "聚",
      "聞",
      "聯",
      "聰",
      "聲",
      "聳",
      "聶",
      "職",
      "聽",
      "聾",
      "聿",
      "肀",
      "肅",
      "肆",
      "肉",
      "肋",
      "肌",
      "肖",
      "肙",
      "肚",
      "肝",
      "股",
      "肢",
      "肥",
      "肩",
      "肪",
      "肯",
      "肰",
      "育",
      "肴",
      "肺",
      "胃",
      "背",
      "胎",
      "胖",
      "胞",
      "胡",
      "胥",
      "胸",
      "能",
      "脂",
      "脅",
      "脆",
      "脈",
      "脊",
      "脖",
      "脣",
      "脫",
      "脹",
      "脾",
      "腎",
      "腐",
      "腔",
      "腕",
      "腥",
      "腦",
      "腫",
      "腰",
      "腳",
      "腸",
      "腹",
      "腿",
      "膀",
      "膊",
      "膏",
      "膚",
      "膜",
      "膝",
      "膠",
      "膨",
      "膩",
      "膿",
      "臂",
      "臉",
      "臘",
      "臟",
      "臣",
      "臤",
      "臥",
      "臧",
      "自",
      "臭",
      "臱",
      "至",
      "致",
      "臼",
      "臽",
      "臿",
      "舀",
      "舂",
      "舄",
      "與",
      "興",
      "舊",
      "舌",
      "舍",
      "舒",
      "舔",
      "舖",
      "舛",
      "舜",
      "舞",
      "舟",
      "航",
      "般",
      "舵",
      "船",
      "艇",
      "艘",
      "艙",
      "艦",
      "艮",
      "良",
      "艱",
      "色",
      "艹",
      "艾",
      "芇",
      "芋",
      "芒",
      "芝",
      "芬",
      "芭",
      "芳",
      "芹",
      "芻",
      "芽",
      "苔",
      "苗",
      "苛",
      "苜",
      "苟",
      "若",
      "苦",
      "英",
      "茁",
      "茂",
      "范",
      "茄",
      "茉",
      "茫",
      "茶",
      "荅",
      "荊",
      "荒",
      "荔",
      "荷",
      "莉",
      "莊",
      "莓",
      "莖",
      "莫",
      "莽",
      "菇",
      "菊",
      "菌",
      "菐",
      "菜",
      "菠",
      "華",
      "菲",
      "菸",
      "萄",
      "萈",
      "萌",
      "萍",
      "萎",
      "萬",
      "萱",
      "萹",
      "葉",
      "葛",
      "葡",
      "董",
      "葬",
      "葷",
      "蒂",
      "蒙",
      "蒜",
      "蒦",
      "蒸",
      "蒼",
      "蓄",
      "蓋",
      "蓓",
      "蓬",
      "蓮",
      "蓺",
      "蔑",
      "蔔",
      "蔗",
      "蔣",
      "蔥",
      "蔬",
      "蔭",
      "蔽",
      "蕉",
      "蕩",
      "蕭",
      "蕾",
      "薄",
      "薑",
      "薦",
      "薪",
      "薯",
      "藉",
      "藍",
      "藏",
      "藝",
      "藤",
      "藥",
      "藹",
      "藻",
      "蘆",
      "蘇",
      "蘋",
      "蘭",
      "蘿",
      "虍",
      "虎",
      "虐",
      "虒",
      "虔",
      "虚",
      "虛",
      "虜",
      "號",
      "虧",
      "虫",
      "虹",
      "虽",
      "蚊",
      "蚤",
      "蚵",
      "蛀",
      "蛋",
      "蛙",
      "蛛",
      "蜀",
      "蜂",
      "蜘",
      "蜜",
      "蝕",
      "蝦",
      "蝴",
      "蝶",
      "蝸",
      "螂",
      "螃",
      "融",
      "螞",
      "螢",
      "蟑",
      "蟬",
      "蟲",
      "蟹",
      "蟻",
      "蠅",
      "蠟",
      "蠢",
      "蠶",
      "蠻",
      "血",
      "行",
      "衍",
      "術",
      "衛",
      "衡",
      "衣",
      "衤",
      "表",
      "衫",
      "衰",
      "衷",
      "袁",
      "袋",
      "袍",
      "袖",
      "被",
      "袱",
      "裁",
      "裂",
      "裔",
      "裕",
      "裙",
      "補",
      "裝",
      "裡",
      "裳",
      "裸",
      "裹",
      "製",
      "複",
      "褒",
      "褪",
      "褱",
      "褲",
      "襄",
      "襟",
      "襪",
      "襯",
      "襲",
      "襾",
      "西",
      "覀",
      "要",
      "覃",
      "覆",
      "見",
      "規",
      "覓",
      "視",
      "覦",
      "親",
      "覬",
      "覺",
      "覽",
      "角",
      "觜",
      "解",
      "觸",
      "言",
      "訂",
      "計",
      "訊",
      "討",
      "訓",
      "訕",
      "託",
      "訝",
      "訟",
      "訣",
      "訧",
      "訪",
      "設",
      "訴",
      "註",
      "詐",
      "評",
      "詢",
      "試",
      "詭",
      "話",
      "詳",
      "詹",
      "誇",
      "誌",
      "認",
      "誓",
      "誕",
      "誘",
      "語",
      "誣",
      "誤",
      "誦",
      "誨",
      "說",
      "誰",
      "課",
      "誹",
      "誼",
      "調",
      "諂",
      "談",
      "請",
      "諒",
      "諜",
      "諧",
      "諮",
      "諷",
      "諸",
      "諾",
      "謀",
      "謁",
      "謂",
      "謊",
      "謗",
      "謙",
      "講",
      "謝",
      "謠",
      "謹",
      "譁",
      "證",
      "譏",
      "識",
      "譜",
      "警",
      "譬",
      "譯",
      "議",
      "譴",
      "護",
      "譽",
      "讀",
      "變",
      "讓",
      "谷",
      "豁",
      "豆",
      "豈",
      "豊",
      "豎",
      "豐",
      "豔",
      "豕",
      "豙",
      "豚",
      "象",
      "豦",
      "豪",
      "豫",
      "豬",
      "豸",
      "豹",
      "貇",
      "貌",
      "貓",
      "貝",
      "貞",
      "負",
      "貢",
      "貧",
      "販",
      "貫",
      "責",
      "貳",
      "貴",
      "貶",
      "買",
      "貸",
      "貿",
      "賀",
      "賁",
      "賂",
      "賃",
      "賄",
      "資",
      "賊",
      "賓",
      "賜",
      "賞",
      "賠",
      "賢",
      "賣",
      "賤",
      "賦",
      "質",
      "賭",
      "賴",
      "賺",
      "購",
      "賽",
      "贅",
      "贈",
      "贊",
      "贏",
      "贓",
      "贝",
      "负",
      "赤",
      "赦",
      "赫",
      "走",
      "赴",
      "起",
      "趁",
      "超",
      "趕",
      "趙",
      "趟",
      "趣",
      "趨",
      "足",
      "趴",
      "趾",
      "跌",
      "跑",
      "跛",
      "距",
      "跡",
      "跤",
      "跨",
      "跪",
      "路",
      "跳",
      "踏",
      "踐",
      "踢",
      "踩",
      "踴",
      "蹄",
      "蹈",
      "蹟",
      "蹤",
      "蹦",
      "蹲",
      "蹺",
      "躁",
      "躍",
      "身",
      "躬",
      "躲",
      "躺",
      "軀",
      "車",
      "軌",
      "軍",
      "軟",
      "軸",
      "較",
      "載",
      "輒",
      "輔",
      "輕",
      "輛",
      "輝",
      "輟",
      "輩",
      "輯",
      "輸",
      "輻",
      "輾",
      "輿",
      "轄",
      "轉",
      "轍",
      "轎",
      "轟",
      "辛",
      "辜",
      "辟",
      "辡",
      "辣",
      "辦",
      "辨",
      "辭",
      "辮",
      "辯",
      "辰",
      "辱",
      "農",
      "辶",
      "迄",
      "迅",
      "迎",
      "近",
      "返",
      "迪",
      "迫",
      "述",
      "迴",
      "迷",
      "追",
      "退",
      "送",
      "逆",
      "逍",
      "透",
      "逐",
      "逗",
      "逛",
      "逝",
      "逞",
      "速",
      "造",
      "逢",
      "連",
      "逮",
      "進",
      "逸",
      "逼",
      "逾",
      "遀",
      "遂",
      "遊",
      "運",
      "遍",
      "道",
      "達",
      "違",
      "遙",
      "遛",
      "遜",
      "遞",
      "遠",
      "遣",
      "適",
      "遭",
      "遮",
      "遲",
      "遵",
      "遷",
      "選",
      "遺",
      "遼",
      "邀",
      "邁",
      "邊",
      "邏",
      "那",
      "邦",
      "邪",
      "郊",
      "郎",
      "部",
      "郭",
      "都",
      "鄉",
      "鄙",
      "鄭",
      "鄰",
      "酉",
      "酋",
      "酌",
      "配",
      "酒",
      "酗",
      "酥",
      "酬",
      "酵",
      "酷",
      "酸",
      "醇",
      "醉",
      "醋",
      "醒",
      "醜",
      "醞",
      "醫",
      "醬",
      "釀",
      "釁",
      "釆",
      "采",
      "釋",
      "里",
      "重",
      "野",
      "量",
      "釐",
      "金",
      "釘",
      "釣",
      "鈍",
      "鈔",
      "鈕",
      "鈣",
      "鈴",
      "鉅",
      "鉛",
      "鉢",
      "銀",
      "銘",
      "銜",
      "銳",
      "銷",
      "鋁",
      "鋒",
      "鋼",
      "錄",
      "錢",
      "錦",
      "錫",
      "錯",
      "錶",
      "鍊",
      "鍋",
      "鍛",
      "鍵",
      "鍾",
      "鎖",
      "鏟",
      "鏡",
      "鐵",
      "鑄",
      "鑑",
      "鑰",
      "鑲",
      "鑼",
      "鑽",
      "長",
      "镸",
      "門",
      "閉",
      "閏",
      "閒",
      "間",
      "閣",
      "閥",
      "閩",
      "閱",
      "闆",
      "闊",
      "闌",
      "闖",
      "關",
      "闢",
      "阝",
      "阱",
      "防",
      "阻",
      "阿",
      "附",
      "陋",
      "陌",
      "降",
      "限",
      "陡",
      "院",
      "陣",
      "陪",
      "陰",
      "陵",
      "陶",
      "陷",
      "陸",
      "隆",
      "隊",
      "隋",
      "階",
      "隔",
      "隙",
      "際",
      "障",
      "隧",
      "險",
      "隱",
      "隶",
      "隸",
      "隹",
      "隺",
      "隻",
      "雀",
      "雁",
      "雄",
      "雅",
      "雇",
      "雈",
      "雌",
      "雍",
      "雐",
      "雔",
      "雕",
      "雖",
      "雙",
      "雚",
      "雛",
      "雜",
      "雞",
      "離",
      "難",
      "雨",
      "零",
      "雷",
      "電",
      "需",
      "震",
      "霉",
      "霍",
      "霜",
      "霝",
      "霞",
      "霧",
      "霸",
      "靈",
      "靑",
      "青",
      "靜",
      "非",
      "靠",
      "面",
      "革",
      "靴",
      "鞋",
      "鞏",
      "鞠",
      "鞭",
      "韋",
      "韌",
      "韓",
      "韭",
      "韱",
      "音",
      "韻",
      "響",
      "頁",
      "頂",
      "頃",
      "順",
      "須",
      "頌",
      "預",
      "頑",
      "頒",
      "頓",
      "頗",
      "領",
      "頰",
      "頸",
      "頹",
      "頻",
      "顆",
      "題",
      "額",
      "顏",
      "願",
      "顛",
      "顧",
      "顫",
      "顯",
      "顱",
      "風",
      "颱",
      "颳",
      "飄",
      "飆",
      "食",
      "飢",
      "飩",
      "飪",
      "飬",
      "飯",
      "飲",
      "飼",
      "飽",
      "飾",
      "餃",
      "餅",
      "養",
      "餌",
      "餐",
      "餒",
      "餓",
      "餘",
      "餚",
      "餛",
      "餡",
      "館",
      "餵",
      "饅",
      "饋",
      "饒",
      "饗",
      "首",
      "香",
      "馨",
      "馬",
      "馮",
      "馳",
      "馴",
      "駁",
      "駐",
      "駕",
      "駛",
      "駝",
      "駦",
      "駭",
      "騎",
      "騙",
      "騰",
      "騷",
      "驅",
      "驕",
      "驗",
      "驚",
      "驟",
      "驢",
      "骨",
      "髒",
      "髓",
      "體",
      "高",
      "髟",
      "髦",
      "髮",
      "鬆",
      "鬍",
      "鬚",
      "鬥",
      "鬧",
      "鬯",
      "鬱",
      "鬲",
      "鬳",
      "鬼",
      "魁",
      "魂",
      "魄",
      "魅",
      "魏",
      "魔",
      "魚",
      "魯",
      "魷",
      "鮪",
      "鮭",
      "鮮",
      "鯨",
      "鱗",
      "鳥",
      "鳩",
      "鳳",
      "鳴",
      "鴉",
      "鴛",
      "鴦",
      "鵝",
      "鵲",
      "鶯",
      "鶴",
      "鷹",
      "鹵",
      "鹹",
      "鹽",
      "鹿",
      "麗",
      "麥",
      "麵",
      "麻",
      "麼",
      "黃",
      "黄",
      "黍",
      "黎",
      "黏",
      "黑",
      "默",
      "點",
      "黨",
      "黯",
      "黽",
      "鼓",
      "鼠",
      "鼻",
      "齊",
      "齋",
      "齒",
      "齡",
      "齣",
      "龍",
      "龐",
      "龜",
      "龠",
      "龥",
      "龰",
      "龴",
      "龶",
      "龷",
      "龹",
      "𠀐",
      "𠁳",
      "𠂇",
      "𠂉",
      "𠂎",
      "𠂑",
      "𠂔",
      "𠂤",
      "𠂭",
      "𠃊",
      "𠃌",
      "𠃜",
      "𠓜",
      "𠔏",
      "𠕁",
      "𠙽",
      "𠚍",
      "𠣜",
      "𠤕",
      "𠦒",
      "𠦝",
      "𠩺",
      "𠪚",
      "𠫔",
      "𠫝",
      "𠫯",
      "𠬛",
      "𠬝",
      "𠬶",
      "𠮛",
      "𠮷",
      "𠱠",
      "𠳋",
      "𡉀",
      "𡗗",
      "𡗜",
      "𡗞",
      "𡨄",
      "𡩜",
      "𡭴",
      "𡯄",
      "𡰪",
      "𡰯",
      "𡱒",
      "𡵂",
      "𡿺",
      "𢆉",
      "𢆶",
      "𢆸",
      "𢇁",
      "𢇇",
      "𢎥",
      "𢎨",
      "𢖻",
      "𢛳",
      "𢦏",
      "𢧜",
      "𢼸",
      "𣌢",
      "𣍢",
      "𣎆",
      "𣎳",
      "𣏂",
      "𣥂",
      "𣦼",
      "𣪠",
      "𣳾",
      "𣶒",
      "𤔔",
      "𤯝",
      "𤰔",
      "𤴓",
      "𤽄",
      "𥁕",
      "𥃭",
      "𥅛",
      "𥝢",
      "𦈢",
      "𦍌",
      "𦍎",
      "𦍒",
      "𦐇",
      "𦔻",
      "𦗟",
      "𦣻",
      "𦥔",
      "𦥯",
      "𦰩",
      "𧆨",
      "𧈧",
      "𧘇",
      "𧰨",
      "𧴪",
      "𨊠",
      "𨊥",
      "𨥫",
      "𨾴",
      "𩾏"
    ],
    "rare": [
      "㚇",
      "㧜",
      "㨨",
      "㼌",
      "䖭",
      "下",
      "丏",
      "乾",
      "互",
      "仄",
      "仕",
      "伊",
      "俊",
      "倩",
      "僕",
      "兇",
      "兮",
      "别",
      "刺",
      "勾",
      "匪",
      "升",
      "卞",
      "吁",
      "吅",
      "咎",
      "囊",
      "囙",
      "圂",
      "夰",
      "奈",
      "好",
      "威",
      "媷",
      "密",
      "寇",
      "寽",
      "尨",
      "就",
      "屑",
      "岑",
      "弄",
      "弇",
      "强",
      "律",
      "徙",
      "忌",
      "恬",
      "悘",
      "患",
      "戢",
      "戲",
      "拔",
      "捕",
      "敃",
      "斛",
      "施",
      "旅",
      "昬",
      "晉",
      "服",
      "梄",
      "楙",
      "殄",
      "毒",
      "沃",
      "沛",
      "沮",
      "河",
      "泰",
      "流",
      "浪",
      "渠",
      "焊",
      "焱",
      "熱",
      "燮",
      "爹",
      "甤",
      "畧",
      "的",
      "盆",
      "盙",
      "眞",
      "移",
      "稍",
      "穀",
      "突",
      "竘",
      "答",
      "筤",
      "粟",
      "粥",
      "糜",
      "糞",
      "素",
      "絭",
      "繁",
      "罽",
      "羴",
      "耎",
      "肥",
      "肩",
      "背",
      "脩",
      "臺",
      "舋",
      "色",
      "芒",
      "芬",
      "荃",
      "萠",
      "葛",
      "蒿",
      "薄",
      "虖",
      "虘",
      "號",
      "行",
      "衍",
      "衡",
      "訇",
      "豩",
      "越",
      "遠",
      "適",
      "遽",
      "邛",
      "部",
      "酓",
      "釜",
      "阞",
      "除",
      "隆",
      "雋",
      "雩",
      "霍",
      "靡",
      "餐",
      "魁",
      "黎",
      "黹",
      "鼎",
      "𠇍",
      "𠬢",
      "𡉼",
      "𡿪",
      "𢦑",
      "𥁓",
      "𥃺"
    ],
    "uncommon": [
      "⺆",
      "㕡",
      "㗊",
      "㚒",
      "㝵",
      "㞢",
      "㣎",
      "䏌",
      "䖝",
      "䩻",
      "丕",
      "丹",
      "亟",
      "亩",
      "仁",
      "以",
      "休",
      "位",
      "佘",
      "來",
      "倝",
      "備",
      "克",
      "內",
      "典",
      "冀",
      "冥",
      "処",
      "凹",
      "刁",
      "切",
      "劉",
      "助",
      "劵",
      "勃",
      "動",
      "匛",
      "匧",
      "匱",
      "匽",
      "匿",
      "午",
      "南",
      "即",
      "卵",
      "厈",
      "厘",
      "厸",
      "叧",
      "叩",
      "只",
      "吊",
      "否",
      "含",
      "吴",
      "咢",
      "善",
      "嗇",
      "嘗",
      "噩",
      "嚴",
      "四",
      "國",
      "均",
      "坎",
      "坒",
      "堂",
      "堅",
      "壹",
      "夐",
      "夒",
      "夲",
      "奋",
      "契",
      "嬴",
      "存",
      "季",
      "孤",
      "孨",
      "孱",
      "宁",
      "宅",
      "守",
      "宰",
      "寅",
      "寜",
      "尺",
      "尾",
      "局",
      "居",
      "屏",
      "巢",
      "巵",
      "巷",
      "巸",
      "席",
      "常",
      "幼",
      "店",
      "弁",
      "引",
      "弘",
      "彦",
      "念",
      "恣",
      "悉",
      "悶",
      "惠",
      "惢",
      "愛",
      "戉",
      "戚",
      "戛",
      "戻",
      "扇",
      "扈",
      "拍",
      "拑",
      "攴",
      "放",
      "敄",
      "敢",
      "數",
      "旋",
      "族",
      "昝",
      "昫",
      "昱",
      "晃",
      "最",
      "杀",
      "栗",
      "條",
      "楚",
      "檗",
      "欒",
      "歇",
      "歨",
      "歰",
      "歲",
      "歷",
      "殷",
      "殿",
      "毀",
      "毚",
      "毳",
      "氣",
      "永",
      "江",
      "沙",
      "沾",
      "泉",
      "泊",
      "法",
      "洛",
      "洼",
      "浦",
      "涖",
      "淫",
      "滿",
      "潘",
      "焉",
      "熏",
      "燕",
      "爯",
      "牟",
      "狄",
      "猗",
      "獄",
      "珤",
      "產",
      "甾",
      "畟",
      "癸",
      "皅",
      "皋",
      "盈",
      "眇",
      "眘",
      "睿",
      "瞢",
      "矍",
      "磨",
      "禹",
      "禽",
      "科",
      "秦",
      "稟",
      "穵",
      "窄",
      "筮",
      "算",
      "節",
      "类",
      "累",
      "縕",
      "羕",
      "翁",
      "翕",
      "翰",
      "耦",
      "耶",
      "肯",
      "脊",
      "臥",
      "臬",
      "臾",
      "英",
      "茶",
      "莽",
      "著",
      "薛",
      "藝",
      "藺",
      "蘇",
      "虐",
      "虜",
      "蚩",
      "蟲",
      "衰",
      "袞",
      "裊",
      "誊",
      "豖",
      "豪",
      "貌",
      "貍",
      "貢",
      "賈",
      "赦",
      "路",
      "輦",
      "轉",
      "辱",
      "追",
      "進",
      "達",
      "遷",
      "邑",
      "邪",
      "都",
      "醮",
      "閑",
      "閔",
      "閭",
      "閵",
      "阜",
      "隡",
      "隼",
      "霜",
      "霸",
      "頓",
      "顛",
      "飤",
      "魏",
      "魯",
      "鮮",
      "鴈",
      "麃",
      "麼",
      "鼓",
      "鼻",
      "𠂆",
      "𠂊",
      "𠂋",
      "𠌵",
      "𠧒",
      "𠮠",
      "𡌥",
      "𡕥",
      "𡘽",
      "𡩧",
      "𢼄",
      "𣏟",
      "𣢟",
      "𣪊",
      "𣬉",
      "𤆛",
      "𤍾",
      "𤕻",
      "𤿺",
      "𥃲",
      "𥏫",
      "𥬥",
      "𦆕",
      "𦙲",
      "𦣞"
    ]
  }
}
